import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { DecimalPipe, Location as History } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import Feature from "ol/Feature";
import Map from "ol/Map";
import Overlay from "ol/Overlay";
import View from "ol/View";
import { FullScreen, defaults as defaultControls } from "ol/control";
import * as olExtent from "ol/extent";
import MultiLineString from "ol/geom/MultiLineString";
import MultiPolygon from "ol/geom/MultiPolygon";
import Point from "ol/geom/Point";
import Select from "ol/interaction/Select";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { fromLonLat } from 'ol/proj';
import { Cluster, OSM, Vector as VectorSource } from "ol/source";
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text
} from "ol/style";
import { parsemapItem } from "src/app/core/util/computemaplayers";
import {
  Coordinate,
  Location,
} from "../../../../../akita/locations/state/location.model";
import { PubsubService } from "../../../../../core/service/api/pubsub.service";
import { Page } from "../../../../../core/util/abstract/page";
import { Globals } from "../../../../../globals";

import { Router } from "@angular/router";
import collect from 'collect.js';
import moment from "moment";
import { DaterangepickerDirective } from "ngx-daterangepicker-material";
import { NgxXml2jsonService } from "ngx-xml2json";
import posthog from 'posthog-js';
import { BehaviorSubject, EMPTY, Observable, asapScheduler, combineLatest, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { ProjectConfigsService } from "src/app/akita/project-configs/state/project-configs.service";
import { SubprojectQuery } from "src/app/akita/subproject/state/subprojects.query";
import { SubprojectsService } from "src/app/akita/subproject/state/subprojects.service";
import { MapService } from "src/app/core/service/api/map.service";
import { WithParams } from "src/app/core/service/common/with-params";
import { overpassApiQuery } from "src/app/core/util/Queries/overpass-query";
import { integrationError, integrationValidationArcGis } from "src/app/core/util/integration";
import { arcGisIntegrationSymbology, arcGisIntegrationSymbologyDefault, createMultiPolygon, getRegExpURL, openLayerMaping, openLayerPrivateMaping, setFeatureStyle, setItemsIcons, setMultipleSymobologyStyleColor, setTransprantFeatures } from "src/app/core/util/mapModal";
import { showFeedbackError } from "src/app/core/util/notification";
import { wmsFeatureget, wmsURLSet, resolveWfsOutputFormat } from "src/app/core/util/openDataModals";
import { translate } from "@jsverse/transloco";
import { GenericInfoModalComponent } from "src/app/shared/components/modal/generic-info-modal/generic-info-modal.component";
import { StakeholderNewMapComponent } from "src/app/shared/components/modal/stakeholder-new-map/stakeholder-new-map.component";
import { getColorCode, hexToRgb } from "../../../../../core/util/color";
import { ModalEnum, modalConfig } from "../../../../../core/util/modalConfig";
import { ActivityNewComponent } from "../../../../../shared/components/modal/activity-new/activity-new.component";
import { ComplaintNewComponent } from "../../../../../shared/components/modal/complaint-new/complaint-new.component";
import { IssueNewComponent } from "../../../../../shared/components/modal/issue-new/issue-new.component";
import { DecisionNewComponent } from "../../../../../shared/components/modal/requirement-new/decision-new.component";
import { StakeholderNewComponent } from "../../../../../shared/components/modal/stakeholder-new/stakeholder-new.component";
import { ItemsListComponent } from "../../component/items-list/items-list.component";
import { OpenlayersRightPanelComponent } from "../../openlayers-rightpanel/openlayers-rightpanel.component";
import { OpenlayersSidebarV2Component } from "../../openlayers-sidebar-v2/openlayers-sidebar-v2.component";
import { OpenDataLayers } from "./opendata-layers";
import { OpenlayersDrawing } from "./openlayers-drawing";
import { OpenlayersTooltip } from "./openlayers-tooltip";
import { MapDataService } from "src/app/core/service/api/map-data.service";
import Bugsnag from "@bugsnag/js";
import { ContextDetailComponent } from "../../../context/page/context-detail/context-detail.component";
import GeoJSON from "ol/format/GeoJSON";
import * as turf from '@turf/turf';
import { ContextNewComponent } from "src/app/shared/components/modal/context-new/context-new.component";
import { ContextService } from "src/app/core/service/api/context.service";
import { ProjectShareComponent } from "src/app/shared/components/modal/project-share/project-share.component";

moment.locale("nl");

declare let ol: any;
declare let $: any;
export let isExtent: boolean = false;
@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.sass"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapComponent extends Page implements AfterViewInit {
  public showProjectPopup: boolean = false;
  public projectPopupData: { name: string, type: string, project: any } = { name: '', type: '', project: null };
  private projectOverlay: Overlay;
  @ViewChild('popupContentContainer') popupContentContainer: ElementRef;
  public map: Map;
  public myElement: any
  public showPanel: boolean;
  public showMakerPopup: boolean = false;
  public overPassNodes: any = [];
  public contextTypes: any = ['emotional','social','regulatory','political','physical'];
  public overPassFeature: any;
  public sidebarButtons = ["layer", "draw"];
  public coordinate;
  public main_MapCoordinates: any;
  public randomId = Math.random().toString(36).substring(7);
  private basicColor: string = "#3C8CAA";
  private locationsSbj: BehaviorSubject<Location[]> = new BehaviorSubject<
    Location[]
  >([]);
  private lastClickedProjectFeature: any;
  private layers = {};
  private overlay: Overlay;
  private vectorLayers = {};
  private kmls = {};
  relationLayer: any;
  private vector;
  private pinTooltipOverlay: any;
  private popupTimeout: any;
  private popupBeingShown = false;
  public activation = false;
  public openDataResponse: any;
  public locations$: Observable<Location[]> = this.locationsSbj.asObservable();
  public BBOX: any[] = [];
  public subprojects: any[] = [];
  showPopup: boolean = false;
  pageSubTitle = "";
  pageTitle = "";
  mainClass = "";
  featureNames: string[] = [];
  public showToggle: Boolean = false;
  public locale = {
    applyLabel: "Toepassen",
    cancelLabel: "Sluiten",
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.months(),
    firstDay: moment.localeData().firstDayOfWeek(),
  };
  public dateRange: {
    startDate: any;
    endDate: any;
  } = {
      startDate: "",
      endDate: "",
    };
  public owlDateRange: any[] = [];
  select: any;
  getCoordinate: any
  public arcGis_connectedItems = ['Activiteiten', 'Meldingen', 'Klanteisen', 'Klantwensen', 'Issues', 'Middelen', 'Stakeholders']
  public buttons: string[] = ["layer", "add-stakeholder"];
  public locatableType: string;
  public nohoverMapDetail: boolean = false;
  private drawing: OpenlayersDrawing;
  private selectedToolSbj = new BehaviorSubject(null);
  public layerLoadInterval: any[] = [];
  public layerSymbologyInterval: any[] = [];
  private selectedTool$: Observable<string> =
    this.selectedToolSbj.asObservable();
  private purposeToolSbj = new BehaviorSubject(null);
  public purposeTool$: Observable<string> = this.purposeToolSbj.asObservable();
  public arcGisLayers: any[] = [];
  @Input() mapData: any = null;
  @Input() isExtent: boolean = true;
  @Input() contextPanel: boolean = false;
  @Input() headerFalse: string = "";
  @Input() public hideSidePanel = false;
  @Output() openlayerralationLoader: EventEmitter<any> = new EventEmitter();
  @Output() public lineDrawEnd: EventEmitter<any> = new EventEmitter();
  @Output() public pointDrawEnd: EventEmitter<any> = new EventEmitter();
  @Output() public areaDrawEnd: EventEmitter<any> = new EventEmitter();
  @ViewChild(OpenlayersSidebarV2Component, { static: false })
  public sidebar: OpenlayersSidebarV2Component;
  @ViewChild(OpenlayersRightPanelComponent, { static: false })


  public rightpanel: OpenlayersRightPanelComponent;
  @ViewChild(ItemsListComponent, { static: false })
  public itemsList: ItemsListComponent;
  @ViewChild("mapContainer", { static: false })
  private mapContainer: ElementRef;
  @ViewChild(DaterangepickerDirective, { static: true })
  public pickerDirective: DaterangepickerDirective;
  @ViewChild("popup", { read: ElementRef }) popup: ElementRef;
  @ViewChild('customPopup') customPopupElement: ElementRef;
  public enableLayers: any[] = [];
  public arcGisToken: string;
  private _arcGisLayerExtents: { [layername: string]: [number, number, number, number] } = {};
  public errorIntegration: boolean = false;
  public errorIntegrationEnterprise: boolean = false;
  public isAdmin: boolean = false;
  public is_loadOverpassApi: boolean = false;
  public activeArcGis: string = 'arcgis';
  public geojsonArcGisType: string = 'pgeojson';
  public integrationCheck: string;
  private publicLayers: OpenDataLayers;
  private symbolicName: any[] = [];
  public openLayersResp: any[] = [];
  public tempVar: any = '1212';
  public layerItemClicked: boolean = false;
  public bufferedBox: any;
  public allPolygonFeatures: any[] = [];
  vectorSource: VectorSource;
  vectorLayer: any;
  constructor(
    public pubsub: PubsubService,
    private cd: ChangeDetectorRef,
    public globals: Globals,
    private dialog: MatDialog,
    public _rout: Router,
    public _projectConfigsService: ProjectConfigsService,
    private subProjectQuery: SubprojectQuery,
    public _subproject: SubprojectsService,
    public _contextsService: ContextService,
    public _mapServices: MapService,
    public _mapDataService: MapDataService,
    public location: History,
    private ngxXml2jsonService: NgxXml2jsonService,
    private renderer: Renderer2, private el: ElementRef
  ) {
    super(pubsub, globals);

  }

  public ngOnInit(): void {
    isExtent = this.isExtent;
    this.errorIntegration = integrationError(this.globals, 'arcgis_enabled');
    this.errorIntegrationEnterprise = integrationError(this.globals, 'arcgis_enterprise_enabled');
    this.isAdmin = this.globals.user.isAdmin;
    if (this.globals.projectConfigs["services.integration.arcgis_enterprise.enabled"]) {
      this.activeArcGis = 'arcgis_enterprise';
      this.geojsonArcGisType = 'geojson'
    }
    this.integrationCheck = integrationValidationArcGis(this.globals, 'arcgis', 'arcgis_enterprise', 'arcgis_enabled', 'arcgis_enterprise_enabled', this.errorIntegration, this.errorIntegrationEnterprise);
    if (this.integrationCheck === 'project') {
      this.integrationSetup();
    }
    if (this.headerFalse == "false") {
      this.mainClass = "right_col";
    } else {
      this.mainClass = "page-map_main-container";
    }
    this.pageSubTitle = '';
    this.pageTitle = this.contextPanel ? 'menu.analysis':'';
    if (
      document.location.hostname === "app.getdialog.nl" &&
      this.globals.project.customers &&
      this.globals.project.customers.name &&
      !this.globals.project.customers.name.toLowerCase().includes("van gelder")
    ) {
      this.buttons = ["layer"];
    }
    this.coordinate = [6.661594, 50.433237];
    if (this._mapServices.layers == undefined) {
      this._mapServices.layers = this._mapServices.publicLayers.subscribe((res) => {
        this.loadPublicLayers(res);
        this._mapServices.layers = undefined;
      });
    }

    if (this.mapData && this.mapData?.type === 'geojson') {
      this._mapServices.getSavedGeoJsonLayers().subscribe((res: any[]) => {
        if (!res || !res.length) {
          return;
        }
        res.forEach(element => {
          this._mapServices.getGeoJsonFeatures(element.id, element.name).subscribe((geoJsonFeatures: any) => {
            this.enableLayers[element.layer_name] = openLayerMaping(element.type, this.enableLayers, element, element.name, '','',0,null,[],{},null, geoJsonFeatures);
            this.map.addLayer(this.enableLayers[element.layer_name]);
          });
        });
      });
    }

    super.ngOnInit();
    posthog.capture('map');

    this._mapServices.panLocation.subscribe((res) => {
      if (res) {
        this.panToLocation(res)
        this.showMakerPopup = true
      } else {
        this.showMakerPopup = false

      }

    })
    const popupContent: HTMLElement = this.popupContentContainer?.nativeElement;

    this._mapServices.popupOverlay = new Overlay({
      element: popupContent,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    if (this.map)
      this.map.addOverlay(this._mapServices.popupOverlay);
  }

  ngAfterViewInit(): void {
    const self = this;
    const defaultControl: any = {
      attribution: false,
    };

    defaultControl.zoomOptions = {
      className: "ol-custom-control_zoom",
    };

    // Detects/waits if the map is rendered
    const observer = new MutationObserver((mutations) => {
      if (!this.mapContainer || !this.mapContainer.nativeElement) {
        return;
      }

      if (
        !this.mapContainer.nativeElement.querySelector("div.ol-unselectable")
      ) {
        return;
      }
      this.applyPinTooltip();
      this.map.updateSize();
      // Adjust tiles size after on window resize
      const self = this;
      this.pubsub.sidebarOpen.subscribe((open) => {
        setTimeout(() => {
          self.map.updateSize();
        }, 500);
      });
      window.onresize = function () {
        setTimeout(() => {
          self.map.updateSize();
        }, 200);
      };
      observer.disconnect();
    });

    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
    const img = document.createElement("img");
    img.src = "/assets/png/fullscreen.png";
    const fullscreenControl = new FullScreen({
      // @ts-ignore
      source: document.querySelector(".nav-sm"),
      labelActive: "\u00d7",
      label: img,
    });
    this.map = new Map({
      target: `map-${this.randomId}`,
      controls: defaultControls().extend([
        fullscreenControl
      ]),

      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        // center: this.coordinate,
        // zoom: 4,
        projection: "EPSG:3857",
        center: [0, 0],
        zoom: 2,
      }),
    });

    fullscreenControl.on("enterfullscreen", () => {
      setTimeout(() => {
        const sidebars = document.querySelectorAll<HTMLElement>(".sidebar-content");
        sidebars.forEach(el => {
          el.style.setProperty("height", "100vh", "important");
        });
      }, 300);
    });
    fullscreenControl.on("leavefullscreen", () => {
      setTimeout(() => {
        const sidebars = document.querySelectorAll<HTMLElement>(".sidebar-content");
        sidebars.forEach(el => {
          el.style.setProperty("height", "75vh", "important");
        });
      }, 300);
    });

    this.initOverlay()
    this.publicLayers = new OpenDataLayers(this._mapServices);
    this.addPontentialStakeholderToKML();
    this.openDataLayers('subproject');
    setTimeout(() => {
      if (this.mapData) {
        if (this.mapData || this.enableLayers[this.mapData.layer_name]) {
          this.openMapItem(this.mapData);
        }
      }
    }, 8000);
    [
      "stakeholders",
      "issues",
      "complaints",
      "requirements",
      "calendars",
      "residents",
      "physical",
      "emotional",
      "regulatory",
      "social",
      "political",
      "irrelevant_contexts"
    ].forEach((e) => {
      this.layers[e] = new VectorSource({});
      const cluster = new Cluster({
        distance: 20,
        source: this.layers[e],
      });
      this.vectorLayers[e] = new VectorLayer({
        source: cluster,
        // @ts-ignore
        name: e,
        style: function (feature) {
          const type = feature.get("features")[0].get("type");
          const length = feature.get("features").length;
          return self.getIconStyle(
            `${type}-multiple.png`,
            feature.get("features")[0],
            length
          );
        },
        zIndex: 999
      });

      // Handle click event on the map
      this.map.on("click", (event)=> {
        const originalEvent = event.originalEvent;
        self._mapServices.keyword = ''
        self._mapServices.vectorSource.clear();
        self._mapServices.popupOverlay.setPosition(undefined);
        event.stopPropagation();
        const clickedFeatures = this.map.getFeaturesAtPixel(event.pixel).filter(f => !f.get('nonInteractive'));
        if (!clickedFeatures || clickedFeatures.length === 0) {
          if (this.showProjectPopup) {
            this.closeProjectPopup();
            return;
          }
        }
        if (clickedFeatures && clickedFeatures.length > 0) {
          const feature = clickedFeatures[0];
          const featureProps = feature.getProperties();

          // Handle allProjects or customerProjects polygon click
          if (featureProps.type === 'allProjects' || featureProps.type === 'customerProjects') {
            this.showProjectPolygonPopup(feature, event.coordinate);
            return;
          }
        if (clickedFeatures && clickedFeatures.length > 0 && clickedFeatures[0].getProperties().features && clickedFeatures[0].getProperties().features.length > 1) {
          // Get the coordinates of the first clicked feature
          const referenceCoordinates = clickedFeatures[0].getProperties().features[0].getGeometry().getCoordinates();

          // Flag to check if all clicked features have the same coordinates
          let allCoordinatesEqual = true;
          function coordinatesAreEqual(coord1, coord2) {
            return coord1[0] === coord2[0] && coord1[1] === coord2[1];
          }
          // Check the coordinates of each clicked feature
          for (let i = 1; i < clickedFeatures[0].getProperties().features.length; i++) {
            const clickedCoordinates = clickedFeatures[0].getProperties().features[i].getGeometry().getCoordinates();

            // Check if the coordinates are the same
            if (!coordinatesAreEqual(clickedCoordinates, referenceCoordinates)) {
              allCoordinatesEqual = false;
              break; // Exit the loop if any coordinates are different
            }
          }

          if (allCoordinatesEqual) {
            self.featureNames = [];
            const element = document.getElementById('popup1');
            element.style.display = 'block';
            // Get the coordinates for placing the popup
            const popupCoordinates = referenceCoordinates;
            for (let i = 0; i < clickedFeatures[0].getProperties().features.length; i++) {
              const feature = clickedFeatures[0].getProperties().features[i];
              self.map.getView().fit(feature.getGeometry().getExtent(), {
                maxZoom: self.map.getView().getZoom(),
              });
              self.featureNames.push(feature);

            }
            self.showPopup = true;

            self.cd.detectChanges();
            // Set the position of the popup
            self.overlay.setPosition(popupCoordinates);

          } else {
            // Coordinates are different for at least one feature
            const element = document.getElementById('popup1');
            element.style.display = 'none';
            this.showPopup = false
          }
        } else {
          // eslint-disable-next-line no-empty
          if (originalEvent.target && originalEvent.target.tagName.toLowerCase() === 'ul') {
          } else {
            const element = document.getElementById('popup1');
            element.style.display = 'none';
            this.showPopup = false
          }
        }

        if (clickedFeatures && clickedFeatures.length > 0 && clickedFeatures[0].getProperties() && clickedFeatures[0].getProperties().type) {
          if (clickedFeatures[0].getProperties().type === '+context') {

            const dialog = this.dialog.open(ContextNewComponent, modalConfig({
              disableClose: true,
              closeOnNavigation: true
            }, ModalEnum.ModalDefault));
            dialog.afterClosed().subscribe((response: any) => {
              console.log('contextResponse: ', response)
            });
          }
        }

        if (clickedFeatures[0].getProperties().relevantType) {
          Object.keys(this.sidebar.enableItemsLayer).forEach((key) => {
            this.sidebar.enableItemsLayer[key] = false;
          });

          const type = clickedFeatures[0].getProperties().relevantType;

          this.sidebar.enableItemsLayer = {
            ...this.sidebar.enableItemsLayer,
            [type] : true
          };


          this.itemsList.onBack()
          if (this.rightpanel.element.classList.contains("collapsed")){
            this.rightpanel._tabitems[0].querySelector("a").click();
          }
          this.cd.detectChanges();
          return;
        }

      if (clickedFeatures && clickedFeatures.length > 0 && clickedFeatures[0].getProperties() && clickedFeatures[0].getProperties().features && clickedFeatures[0].getProperties().features.length > 0) {
        const features = clickedFeatures[0].getProperties().features;
        const id = features[0].get("id");
        const type = features[0].get("type");
        if (id && id !== "" && type && features.length == 1) {
          if (self.rightpanel.element.classList.contains("collapsed"))
            self.rightpanel._tabitems[0].querySelector("a").click();
          const item = self.locationsSbj
            .getValue()
            .filter((l) => l.id == id && l.locatable_type == type);
          self.itemsList.onItemClick(item[0], false);
          self.map.getView().fit(features[0].getGeometry().getExtent(), {
            maxZoom: self.map.getView().getZoom(),
          });
        }
        // else if (id && id !== "" && type && (this.contextTypes.includes(type) || type==='irrelevant_contexts') && features.length == 1){
        //   this.nav(features[0].values_);
        // }
      } else if(this.contextTypes.includes(clickedFeatures[0].getProperties().type)) {
        this.nav(clickedFeatures[0].getProperties());
      }else {
        const feature = clickedFeatures[0].getProperties().features;
        if (!feature) return;
        const layer = self.select.getLayer(feature);
        if (layer.values_.layer_type) {
          if (layer.values_.layer_type == 'subproject') {
            return
          }
        }
      }


    }
  });

      this._mapServices.closeOverlayPopup.subscribe((res) => {
        if (Array.isArray(res) && res.length === 0) {
          const element = document.getElementById('popup1');
          element.style.display = 'none';
          this.showPopup = false;

        } else {
          this.initOverlay()
        }

      })
      this.map.addLayer(this.vectorLayers[e]);
    });
    this.layers["lines"] = new VectorSource({});
    this.map.addLayer(
      new VectorLayer({
        source: this.layers["lines"],
      })
    );
    setTimeout(() => {
      let coord;

      function flattenSubprojects(node: any): any[] {
        const result: any[] = [];

        function recurse(currentNode: any) {
          result.push(currentNode);
          if (currentNode.children && currentNode.children.length) {
            currentNode.children.forEach((child: any) => recurse(child));
          }
        }

        recurse(node);
        return result;
      }

      if (this._rout.url.includes('sub')) {
        const subprojectActive = this.subProjectQuery.getActive();
        if (subprojectActive?.locations?.polygons) {
          this.BBOX = createMultiPolygon(subprojectActive.locations).getGeometry().getExtent();
          coord = subprojectActive.locations.polygons.coordinates[0][0];
          coord = coord[0];
          if (this.map.getSize()) {
            this.map.getView().setCenter(ol.proj.transform(coord, 'EPSG:4326', 'EPSG:3857'));
            this.map.getView().setZoom(10);
          }

          this.subprojects = flattenSubprojects(subprojectActive);

          const allCoordsLonLat = [
            ...this.subprojects.flatMap(sub => sub.locations?.polygons?.coordinates?.[0][0] ?? [])
          ];
          if(this.contextPanel){
            this.bufferMainSubPolygons([], allCoordsLonLat);
          }
        }
      } else {
        if (this.globals.projectConfig.polygons) {
          coord = this.globals.projectConfig.polygons.coordinates[0][0];
          this.BBOX = createMultiPolygon(this.globals.projectConfig).getGeometry().getExtent();
          coord = coord[0];
          if (this.map.getSize()) {
            this.map.getView().setCenter(ol.proj.transform(coord, 'EPSG:4326', 'EPSG:3857'));
            this.map.getView().setZoom(10);
          }
        }

        const allPolygonFeatures = [];

        // Project polygon feature
        const polygonData = this.globals.projectConfig.polygons;
        if (polygonData?.coordinates && polygonData?.coordinates[0]) {
          const polygonFeature = new Feature({
              geometry: new MultiPolygon([
                transformPolygonCoords(polygonData.coordinates[0])
              ])
          });

          polygonFeature.set('type', 'mainPolygon');
          polygonFeature.set('nonInteractive', true); // 👈 Mark this feature
          this.allPolygonFeatures.push(polygonFeature);
        }

        this.subprojects = this.subProjectQuery.getAll();

        const allCoordsLonLat = [
          ...this.globals.projectConfig.polygons?.coordinates?.[0]?.[0] ?? [],
          ...this.subprojects.flatMap(sub => sub.locations?.polygons?.coordinates?.[0][0] ?? [])
        ];
        if(this.contextPanel){
          this.bufferMainSubPolygons(allPolygonFeatures,allCoordsLonLat);
        }
      }
    }, 100);

    function transformPolygonCoords(coords) {
      return coords.map(ring =>
        ring.map(coord => fromLonLat(coord))
      );
    }

    const sidebar = new ol.control.Sidebar({
      element: "sidebar",
      position: "left",
    });
    // this.map.addControl(sidebar);

    asapScheduler.schedule(() => new ol.control.Rightpanel({
      element: "rightpanel",
      position: "right",
    }));

    const tooltip = new OpenlayersTooltip(
      this.map,
      "Klik om te meten",
      this.selectedTool$,
      this.purposeTool$
    );
    this.drawing = new OpenlayersDrawing(
      this.map,
      this.locationsSbj.getValue(),
      this.selectedTool$,
      tooltip,
      {
        maxPoints: 1,
        maxLines: 1,
        maxArea: 0,
      }
    );

    const pointSubscription = this.drawing.pointDrawEnd.subscribe(
      (coordinate: Coordinate) => {
        this.drawingSubscription(
          "points",
          {
            points: {
              type: "MultiPoint",
              coordinates: [],
            },
            locatable_type: this.locatableType,
          },
          coordinate,
          this.pointDrawEnd
        );
      }
    );

    const lineSubscription = this.drawing.lineDrawEnd.subscribe(
      (coordinate: Coordinate) => {
        this.drawingSubscription(
          "lines",
          {
            lines: {
              type: "MultiLineString",
              coordinates: [],
            },
            locatable_type: this.locatableType,
          },
          coordinate,
          this.lineDrawEnd
        );
      }
    );
    const areaSubscription = this.drawing.areaDrawEnd.subscribe(
      (coordinate: Coordinate) => {
        this.drawingSubscription(
          "polygons",
          {
            polygons: {
              type: "MultiPolygon",
              coordinates: [],
            },
            locatable_type: this.locatableType,
          },
          coordinate,
          this.areaDrawEnd
        );
      }
    );

    this.subscriptions = [pointSubscription, lineSubscription];
    // @ts-ignore
    this.select = new Select({ style: false, hitTolerance: 0 });
    if (!this.mapData) {
      this.map.addInteraction(this.select);
    }
    this.map.on('click', function (evt) {
      this._mapServices.popupOverlay.setPosition(undefined);
      this.forEachLayerAtPixel(evt.pixel, (layer) => {
        if (layer.values_.layer_type) {
          if (layer.values_.layer_type == 'wms') {
            self._mapServices.getwmsFeaturesOnClick(wmsURLSet(self.map, self.enableLayers, layer, evt))
              .pipe(
                tap((res: any) => {
                  const parser = new DOMParser();
                  if (self.rightpanel.element.classList.contains("collapsed"))
                    self.rightpanel._tabitems[0].querySelector("a").click();
                  self.itemsList.openDataClick(wmsFeatureget(self.ngxXml2jsonService.xmlToJson(parser.parseFromString(res, 'text/xml')), layer), true);
                }),
              ).subscribe();
          }
        }
      });
    });

    // this.map.on('moveend', (evt) => {
    //   for (const key in this.enableLayers) {
    //     const layer = this.enableLayers[key];
    //     if (layer.getVisible()) {
    //       const matchingItem = this.symbolicName.find((item: any) => item.layer_name === key);
    //       if (matchingItem && layer.getSource().getFeatures().length > 0 && layer.features) {
    //         layer.getSource().getFeatures().forEach(element => {
    //           if (!element.style_) {
    //             setMultipleSymobologyStyleColor(element, matchingItem.symobology, 'arcgis');
    //           }
    //         });
    //       }
    //     }
    //   }
    // });

    this.select.on("select", (e) => {
      if (self.selectedToolSbj.getValue()) return;
      if (
        e.selected &&
        e.selected[0] &&
        e.selected[0].values_ &&
        e.selected[0].values_.features
      ) {
        const features = e.selected[0].values_.features;
        const id = features[0].get("id");
        const type = features[0].get("type");
        if (id && id !== "" && type && !this.contextTypes.includes(type) && type!=='irrelevant_contexts' && features.length == 1) {
          if (self.rightpanel.element.classList.contains("collapsed"))
            self.rightpanel._tabitems[0].querySelector("a").click();
          const item = self.locationsSbj
            .getValue()
            .filter((l) => l.id == id && l.locatable_type == type);
          self.itemsList.onItemClick(item[0], false);
          self.map.getView().fit(features[0].getGeometry().getExtent(), {
            maxZoom: self.map.getView().getZoom(),
          });
        } else if (id && id !== "" && type && this.contextTypes.includes(type) && features.length == 1){
          // this.nav(features[0].values_);
        }
      } else {
        const feature = e.selected[0];
        if (!feature) return;
        const layer = self.select.getLayer(feature);
        if (layer.values_.layer_type) {
          if (layer.values_.layer_type == 'subproject') {
            return
          }
        }

        //Dont show the detail of Pontential_Stakeholder
        // For context not open the right panel when clicked on the feature
        if (feature.values_.type !== 'mainPolygon' && feature.values_.type !== '+context' && feature.values_.type !== 'allProjects' && feature.values_.type !== 'customerProjects' && !feature.values_.isBoxOutline && !feature.values_.relevantType) {
          feature.set("layer", layer.get("name"));
          if (self.rightpanel.element.classList.contains("collapsed"))
            self.rightpanel._tabitems[0].querySelector("a").click();
          if (feature.values_.type !== 'irrelevant_contexts') {
            self.itemsList.openDataClick(feature.getProperties(), true);
          }
          self.select.getFeatures().clear();
          self.overPassDataZoom(feature);
        }
      }
    });
    this._mapServices.vectorSource = new VectorSource();
    this._mapServices.vectorLayer = new VectorLayer({
      source: this._mapServices.vectorSource,
      declutter: true, // 👈 Ensures icons and text aren't overlapped

    });
    this.map.addLayer(this._mapServices.vectorLayer);


  }

  i: number = 0;
  iconX: any;
  iconY: any;


  relevantIcons: { type: string, feature: any }[] = [];

  contextTypeIconsOnBuffer(type: string, toggle: boolean) {
    const coords = this.bufferedBox.geometry.coordinates[0];
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    coords.forEach(([x, y]) => {
      if (x < minX) minX = x;
      if (x > maxX) maxX = x;
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
    });

    const format = new GeoJSON();

    // 🔁 Add or remove feature
    if (toggle) {
      if (!this.relevantIcons.find(f => f.type === type)) {
        this.relevantIcons.push({ type, feature: null });
      }
    } else {
      const index = this.relevantIcons.findIndex(f => f.type === type);
      if (index !== -1) {
        if (this.relevantIcons[index].feature) {
          this.vectorSource.removeFeature(this.relevantIcons[index].feature);
        }
        this.relevantIcons.splice(index, 1);
      }
    }

    // 🧹 Remove old features from buffer
    this.relevantIcons.forEach(icon => {
      if (icon.feature) {
        this.vectorSource.removeFeature(icon.feature);
      }
    });

    // 📐 Recalculate and re-add
    const iconCount = this.relevantIcons.length;
    const availableWidth = (maxX - minX) * 0.4; // 40% of width
    const centerX = (minX + maxX) / 2;
    const iconY = maxY;

    // 👉 FIX: spacing is always based on a maximum of 5 icons layout
    const maxSlots = 5;
    const iconSpacing = availableWidth / (maxSlots - 1);

    function getOffset(index: number): number {
      if (index === 0) return 0; // center
      const step = Math.ceil(index / 2); // 1,1,2,2,...
      const direction = index % 2 === 1 ? -1 : 1; // odd → left, even → right
      return direction * step * iconSpacing;
    }

    this.relevantIcons.forEach((icon, i) => {
      const iconX = centerX + getOffset(i);
      const iconPoint = turf.point([iconX, iconY]);
      const feature = format.readFeature(iconPoint, {
        featureProjection: 'EPSG:3857',
      });
      feature.set('relevantType', icon.type);

      this.vectorSource.addFeature(feature);
      icon.feature = feature;
    });
  }

  bufferMainSubPolygons(allPolygonFeatures = [], allCoordsLonLat) {

    function transformPolygonCoords(coords) {
      return coords.map(ring =>
        ring.map(coord => fromLonLat(coord))
      );
    }


    const format = new GeoJSON();
    if (this.subprojects && this.subprojects.length) {
      this.subprojects.forEach((sub) => {
        const poly = sub.locations?.polygons || null; // assuming each subproject has a `polygons` GeoJSON object
        if (poly) {
          // Create subproject polygon feature
          const subPolygonFeature = new Feature({
            geometry: new MultiPolygon([
              transformPolygonCoords(poly.coordinates[0])
            ]),
          });

          // don't show subproject polygons on load

          // subPolygonFeature.set('type', 'subprojectPolygon');
          // subPolygonFeature.set('id', sub.id);
          // subPolygonFeature.set('nonInteractive', true); // 👈 Mark this feature
          // this.allPolygonFeatures.push(subPolygonFeature);
        }
      });
    }

    // Create one big bbox around all polygons
    const mergedBBox = turf.bbox({ type: "Polygon", coordinates: [allCoordsLonLat] });
    const box = turf.bboxPolygon(mergedBBox);
    this.bufferedBox = turf.buffer(box, 0.05, { units: 'kilometers', steps: 64 });

    const bufferFeature = format.readFeature(this.bufferedBox, {
      featureProjection: 'EPSG:3857'
    });
    bufferFeature.set('isBoxOutline', true);
    bufferFeature.set('nonInteractive', true); // 👈 Mark this feature
    this.allPolygonFeatures.push(bufferFeature);

    // "+" icon at bottom center
    const coords = this.bufferedBox.geometry.coordinates[0];
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    coords.forEach(([x, y]) => {
      if (x < minX) minX = x;
      if (x > maxX) maxX = x;
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
    });
    const centerBottom = [(minX + maxX) / 2, minY];

    // Create bottom center "+"
    const plusBottomFeature = format.readFeature(turf.point(centerBottom), {
      featureProjection: 'EPSG:3857',
    });
    plusBottomFeature.set('iconLabel', '+');
    plusBottomFeature.set('type', '+context');
    this.allPolygonFeatures.push(plusBottomFeature);


    // Source + Layer
    this.vectorSource = new VectorSource({
      features: this.allPolygonFeatures,
    });

    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      style: function (feature) {
        if (feature.get('isBoxOutline')) {
          return new Style({
            stroke: new Stroke({ color: 'blue', width: 2, lineDash: [1, 6] }),
            fill: new Fill({ color: 'rgba(40, 0, 210, 0.15)' }),
            zIndex: 0, // draw behind everything
          });
        }

        if (feature.get('iconLabel')) {
          return new Style({
            image: new Icon({
              src: 'assets/png/plus-circle-rounded-colored.png',
              scale: 0.8,
              anchor: [0.5, 0.5],
            }),
          });
        }

        if (feature.get('relevantType')) {
          const relevantType = feature.get('relevantType');
          return new Style({
            image: new Icon({
              src: `assets/png/relevant-${relevantType}.svg`,
              scale: 1.3,
              anchor: [0.5, 0.5], // ✅ anchor bottom center of icon to the point
            }),
          });
        }

        if (feature.get('type') === 'mainPolygon') {
          return [
            // inner shaded border (fake inner shadow by using fill with opacity)
            new Style({
              fill: new Fill({
                color: 'rgba(40, 0, 210, 0.15)' // stronger opacity for edges
              }),
              stroke: new Stroke({
                color: 'rgba(40, 0, 210, 0.15)',
                width: 8   // wide stroke, but will blend inside due to fill
              }),
              zIndex: 0
            }),

            // main fill (lighter so inner edge looks darker)
            new Style({
              fill: new Fill({
                color: 'rgba(40, 0, 210, 0.15)' // lighter fill for center
              }),
              stroke: new Stroke({
                color: 'rgba(40, 0, 210, 1)', // crisp outer stroke
                width: 4
              }),
              zIndex: 1
            })
          ];
        }

        return new Style({
          fill: new Fill({ color: 'rgba(255, 0, 0, 0.4)' }),
          stroke: new Stroke({ color: 'red', width: 2 }),
        });
      },
      zIndex: 1
    });

    this.map.addLayer(this.vectorLayer);

    // Fit map view to extent of all features
    const extent = this.vectorSource.getExtent();
    this.map.getView().fit(extent, { padding: [20, 20, 20, 20], maxZoom: 16 });

  }

  onSelectFeature(feature: any) {
    const features = feature;
    const id = features.get("id");
    const type = features.get("type");
    if (id && id !== "" && type) {
      if (this.rightpanel.element.classList.contains("collapsed"))
        this.rightpanel._tabitems[0].querySelector("a").click();
      const item = this.locationsSbj
        .getValue()
        .filter((l) => l.id == id && l.locatable_type == type);
      this.itemsList.onItemClick(item[0], false);
      this.map.getView().fit(features.getGeometry().getExtent(), {
        maxZoom: this.map.getView().getZoom(),
      });
    }
  }

  public coordinatesAreEqual(coord1: any, coord2: any) {
    return coord1[0] === coord2[0] && coord1[1] === coord2[1];
  }
  public closePopup() {
    this.showPopup = false
    const element = document.getElementById('popup1');
    element.style.display = 'none';
    this.rightpanel._tabitems[0].querySelector("a").click();

  }

  private initOverlay() {
   if (!this.overlay) {
    const element = document.getElementById('popup1');
    element.style.display = 'block';
    this.overlay = new Overlay({
      element: element,
      positioning: 'bottom-center',
      stopEvent: false,
      offset: [0, -50], // Adjust the offset based on your popup's design
    });

    this.map.addOverlay(this.overlay);
   }
  }
  //integration setup for both user and project
  async integrationSetup() {
    if (Array.isArray(this.globals.enableLayers) && this.globals.enableLayers.length > 0) {
      this.arcGisLayers = this.globals.enableLayers;
      this.arcGisToken = this.globals.arcgisToken;
      await this.sleep(2000);
      await this.openDataLayers('arcgis');
      return true;
    }
    combineLatest([
      this._projectConfigsService.getEnableFeatureLayers(this.activeArcGis),
      this._projectConfigsService.getFreshToken(this.activeArcGis)
    ])
      .pipe(
        tap(async ([layers, arcgis]) => {
          this.setArcGisSubLayers(layers, arcgis);
        }),
        catchError((err) => {
          Bugsnag.notify(JSON.stringify({
            message: 'ArcGis Account Is Not Verified',
            data: err,
          }));
          this.globals.projectConfigs['services.integration.arcgis.enabled'] = false;
          this.globals.projectConfigs['services.integration.arcgis_enterprise.enabled'] = false;
          showFeedbackError(err);
          return throwError(err);
        }),
      ).subscribe();
  }
  /*
    ArcGis Layers Into Sub Layers
  */
  public async setArcGisSubLayers(layers: any, arcgis: any): Promise<void> {
    this.arcGisLayers = [];
    layers.forEach(layer => {
      this._mapServices.getArcGisSubLayers(layer.url, arcgis.token)
        .pipe(
          tap(async (res: any) => {
            res.forEach(item => {
              let foundObject = null;
              if (layer.metadata) {
                if (layer.metadata.length) {
                  foundObject = layer.metadata.find(data => data.layerId === item.id);
                }
              }
              this.arcGisLayers.push({
                name: layer.name,
                layer_name: item.name,
                layer_id: item.id,
                type: item.type,
                geometry_type: item.geometryType,
                url: layer.url,
                owner: layer.owner,
                enabled: layer.enabled,
                metadata: foundObject ? foundObject.metadata : null,
                alldata: layer.metadata ? layer.metadata : null,
              });
            });
            this.arcGisToken = arcgis.token;
            this.globals.enableLayers = this.arcGisLayers;
            this.globals.arcgisToken = this.arcGisToken;
            await this.sleep(2000);
            await this.openDataLayers('arcgis');
          }),
          catchError((err) => {
            if (err?.arcgisError && err?.code === 403) {
              if (!this._mapServices.isArcgisErrorModalOpen) {
                this._mapServices.isArcgisErrorModalOpen = true;
                this.dialog.open(GenericInfoModalComponent, modalConfig(
                  {
                    data: {
                      title: translate('error.arcgis_item_unavailable_title'),
                      body: translate('error.arcgis_item_unavailable'),
                    },
                    disableClose: false,
                    panelClass: 'customized-dialog-container'
                  },
                  ModalEnum.ModalSmall
                )).afterClosed().subscribe(() => {
                  this._mapServices.isArcgisErrorModalOpen = false;
                });
              }
              return EMPTY;
            }
            return throwError(() => err);
          })
        ).subscribe();
    });
  }
  //on toggle open data layers panel
  toggleOpenData(layer: string) {
    // close the popover if open while toggling layers
    if (this.layerItemClicked) {
      const popover: any = document.querySelector(".popover");
      if (popover) popover.style.display = "none";
      this.layerItemClicked = false;
    }
    const visibility = this.kmls[layer].getVisible();
    this.kmls[layer].setVisible(!visibility);
    if (visibility) {
      if (
        !this.rightpanel.element.classList.contains("collapsed") &&
        this.itemsList.itemdetail.feature &&
        this.itemsList.itemdetail.feature.layer == layer
      ) {
        this.itemsList.onBack();
        this.rightpanel._tabitems[0].querySelector("a").click();
        this.cd.detectChanges();
      }
    }
    if (!this.mapData) {
      this.showOpenlayerInSidePanel(layer);
      if (this.rightpanel.element.classList.contains("collapsed")) {
        this.itemsList.hideSerch();
        this.rightpanel._tabitems[0].querySelector("a").click();
        this.showToggle = true;
        this.cd.detectChanges();
      }
      if (
        !collect(this.openDataGetVisible()).contains(true) &&
        !this.kmls["Pontential_Stakeholder"].getVisible() &&
        !this.sidebar.enableItemsLayer['stakeholder'] &&
        !this.sidebar.enableItemsLayer['issue'] &&
        !this.sidebar.enableItemsLayer['complaints'] &&
        !this.sidebar.enableItemsLayer['requirements'] &&
        !this.sidebar.enableItemsLayer['activity'] &&
        !this.sidebar.enableItemsLayer['social'] &&
        !this.sidebar.enableItemsLayer['political'] &&
        !this.sidebar.enableItemsLayer['regulatory'] &&
        !this.sidebar.enableItemsLayer['emotional'] &&
        !this.sidebar.enableItemsLayer['physical']
      ) {
        this.itemsList.onBack();
        this.rightpanel._tabitems[0].querySelector("a").click();
        this.showToggle = false;
        this.cd.detectChanges();
      }
    }
  }

  panToLocation(result: any): void {
    this._mapServices.popupOverlay.setPosition(undefined);
    const coordinates = fromLonLat([result.lon, result.lat]);

    const marker = new Feature({
      geometry: new Point(coordinates)
    });

    // Set the map view to the coordinates
    this.map.getView().animate({
      center: coordinates,
      duration: 1000
    });

    marker.setStyle(new Style({
      image: new CircleStyle({
        radius: 8,
        fill: new Fill({ color: '#2800D2' }),
        stroke: new Stroke({ color: 'white', width: 2 })
      })
    }));

    this._mapServices.vectorSource.addFeature(marker);

    // Show the popup at the marker's coordinates
    this._mapServices.popupOverlay.setPosition(coordinates);

    this.getCoordinate = ol.proj.transform(coordinates, 'EPSG:3857', 'EPSG:4326');

    const typeData = {
      points: {
        type: 'MultiPoint',
        coordinates: [
          [this.getCoordinate[0], this.getCoordinate[1]],
        ]
      },
      locatable_type: this.locatableType,
    }

    this._mapDataService.pointData = {
      locations: typeData,
      log_timestamp: new Date(),
      stakeholdermap: true,
    }
  }

  //on toggle show side panel and layers
  toggleOpenDataLayers(data) {
    if (this.showProjectPopup) {
      this.closeProjectPopup();
    }
    // close the popover if open while toggling layers
    if (this.layerItemClicked) {
      const popover: any = document.querySelector(".popover");
      if (popover) popover.style.display = "none";
      this.layerItemClicked = false;
    }
    //replace wide spaces from the name
    if (data.type!="geojson" && this.mapData?.type != "geojson") {
      data.name = data.name.replaceAll(' ', '')
    }
    const layer = data.name;
    const visibility = data.visibility;
    switch (data.type) {
      case 'subproject': {
        if (!this.enableLayers[layer]) {
          if (data.id) {
            if (data.visibility) {
              this._subproject.select(data.id, new WithParams().with(["locations"]))
                .pipe(
                  tap((res) => {
                    this.enableLayers[layer] = openLayerMaping(data.type, this.enableLayers, res);
                    this.map.addLayer(this.enableLayers[layer]);
                    this.enableLayers[layer].setVisible(visibility);
                    this.openDataZoomExtentLogic(data);
                    this.enableLayers[data.name].getSource().getFeatures().map((feature: any) => {
                      feature.set('name', data.name);
                      feature.set('layer', layer);
                    });
                    this.toggleExtraLayers(layer);
                  })
                ).subscribe();
            }
          }
        } else {
          this.enableLayers[layer].setVisible(visibility);
          this.openDataZoomExtentLogic(data);
          this.toggleExtraLayers(layer);
        }
        return;
      }
      case 'allProjects':
      case 'customerProjects': {
        if (!this.enableLayers[layer]) {
          if (data.id) {
            if (data.visibility) {
              const allProjects = this.globals.allProjects;
              let project;
              if (data.type === 'customerProjects') {
                project = allProjects.internal_projects.filter(item => item.id === data.id)[0];
              } else {
                const ext = allProjects.external_projects as Record<string, any[]>;
                if (ext && typeof ext === 'object') {
                  for (const arr of Object.values(ext)) {
                    project = (arr || []).find((item: any) => item.id === data.id);
                    if (project) break;
                  }
                }
              }
              if(!project?.configs?.polygons?.coordinates && !project?.config?.polygons?.coordinates.length) return;
              this.enableLayers[layer] = openLayerMaping(data.type, this.enableLayers, project);
              this.map.addLayer(this.enableLayers[layer]);
              this.enableLayers[layer].setVisible(visibility);
              this.openDataZoomExtentLogic(data);
              this.enableLayers[data.name].getSource().getFeatures().map((feature: any) => {
                feature.set('name', project.name);
                feature.set('layer', layer);
                feature.set('type', data.type);
                feature.set('id', project.id);
                feature.set('project', project);
              });

              const vectorSource = this.enableLayers[layer].getSource();
              const features = vectorSource.getFeatures();
              if (project.shared_id && project.status !== 'cancelled' && project.status !== 'rejected') {
                const polygonFeature = features[0];
                const extent = polygonFeature.getGeometry().getExtent();
                const center = this.getCenterOfExtent(extent);

                const iconElement = document.createElement('img');
                iconElement.src = '/assets/png/share-alt.png';
                iconElement.style.width = '24px';
                iconElement.style.height = '24px';
                iconElement.style.pointerEvents = 'auto';

                const overlay = new Overlay({
                  position: center,
                  positioning: 'center-center',
                  element: iconElement,
                  stopEvent: false
                });

                this.map.addOverlay(overlay);
              }

              this.toggleExtraLayers(layer);
            }
          }
        } else {
          this.enableLayers[layer].setVisible(visibility);
          this.openDataZoomExtentLogic(data);
          this.toggleExtraLayers(layer);
        }
        return;
      }
      case 'wms': {
        this.enableLayers[layer].setVisible(visibility);
        this.toggleExtraLayers(layer);
        return;
      }
      case 'geojson': {
        if (this.enableLayers[layer]) {
          // Layer already exists: toggle visibility and repopulate right-panel items when turning on
          this.enableLayers[layer].setVisible(visibility);
          this.openDataZoomExtentLogic(data);
          this.toggleExtraLayers(layer);
          if (visibility) {
            this.itemsList.getOpenDataLayerName(layer, true, this.enableLayers[layer].getSource().getFeatures(), data);
            if (this.rightpanel.element.classList.contains("collapsed")) {
              this.itemsList.hideSerch();
              if (window.innerWidth > 500) {
                this.rightpanel._tabitems[0].querySelector("a").click();
              }
              this.showToggle = true;
            }
          }
          break;
        }
        if (!visibility) {
          return;
        }
        this._mapServices.getGeoJsonFeatures(data.id, data.name).subscribe((geoJsonFeatures: any) => {
          this.enableLayers[layer] = openLayerMaping(data.type, this.enableLayers, data, data.name, '','',0,null,[],{},null, geoJsonFeatures);
          this._mapServices.mainLayers = this.enableLayers[layer];
          this.map.addLayer(this.enableLayers[layer]);
          this.enableLayers[layer].setVisible(visibility);
          this.openDataZoomExtentLogic(data);
          this.toggleExtraLayers(layer);
          
          this.itemsList.getOpenDataLayerName(layer, true, this.enableLayers[layer].getSource().getFeatures(), data);
          if (this.rightpanel.element.classList.contains("collapsed")) {
            this.itemsList.hideSerch();
            if (window.innerWidth > 500) {
              this.rightpanel._tabitems[0].querySelector("a").click();
            }
            this.showToggle = true;
          }
        });
        return;
      }
      default: {
        if (!this.enableLayers[layer]) return;
        this._mapServices.mainLayers = this.enableLayers[layer]
        this.enableLayers[layer].setVisible(visibility);
        if (visibility) {
          this._loadWithTargetedExtent(layer, data);
        }
        break;
      }
    }
    if (
      !collect(this.openDataGetVisible()).contains(true) &&
      !this.kmls["Pontential_Stakeholder"].getVisible() &&
      !this.sidebar.enableItemsLayer['stakeholder'] &&
      !this.sidebar.enableItemsLayer['issue'] &&
      !this.sidebar.enableItemsLayer['complaints'] &&
      !this.sidebar.enableItemsLayer['requirements'] &&
      !this.sidebar.enableItemsLayer['activity']
    ) {

      // Features may be on layer["features"] (WMS/subproject) or on the vector source (GeoJSON)
      const layerFeatures = this.enableLayers[layer]?.["features"] ?? this.enableLayers[layer]?.getSource?.()?.getFeatures?.() ?? [];
      this.itemsList.getOpenDataLayerName(layer, false, layerFeatures, data);
      if (!this.rightpanel.element.classList.contains("collapsed") && this.itemsList.itemdetail.feature && this.itemsList.itemdetail.feature.layer == layer) {
        this.itemsList.onBack();
        this.rightpanel._tabitems[0].querySelector("a").click();
      } else {
        if (!this.rightpanel.element.classList.contains("collapsed")) {
          this.itemsList.onBack();
          this.rightpanel._tabitems[0].querySelector("a").click();
        }
      }
    } else {
      this.showOpenDataInSidePanel(layer, data);
      if (this.rightpanel.element.classList.contains("collapsed")) {
        this.itemsList.hideSerch();
        if (window.innerWidth > 500) {
          this.rightpanel._tabitems[0].querySelector("a").click();
        }
        this.showToggle = true;
      }
    }
  }
  //on zoom to extend
  public zoomToOpenDataLayers(data): void {
    if (this.enableLayers[data.name].getVisible()) {
      this.layerLoadInterval.forEach(element => {
        clearInterval(element);
      });
      const extent = this.enableLayers[data.name].getSource().getExtent();
      if (extent && isFinite(extent[0])) {
        this.map.getView().fit(extent, { maxZoom: 15 });
      }
    }
  }
  //wms and subproject toggle handler
  toggleExtraLayers(layer): void {
    if (
      !collect(this.openDataGetVisible()).contains(true) &&
      !this.kmls["Pontential_Stakeholder"].getVisible() &&
      !this.sidebar.enableItemsLayer['stakeholder'] &&
      !this.sidebar.enableItemsLayer['issue'] &&
      !this.sidebar.enableItemsLayer['complaints'] &&
      !this.sidebar.enableItemsLayer['requirements'] &&
      !this.sidebar.enableItemsLayer['activity']
    ) {
      if (!this.rightpanel.element.classList.contains("collapsed")) {
        this.rightpanel._tabitems[0].querySelector("a").click();
      }
    }
  } /*
  On Load Private Features
*/
  public onLoadPrivateFeatures(layer: any, link: string): any {
    return this._mapServices.getPrivateFeatures(layer, link)
  }

  openMapItem(mapItem: any) {
    setTimeout(() => {
      if (this.enableLayers[mapItem.layer_name]) {
        let credentials = false;
        this.openLayersResp.forEach(layer => {
          if (layer.layer_name === mapItem.layer_name) {
            if (layer.layer) {
              if (layer.layer.credentials) {
                if (layer.layer.credentials.username && layer.layer.credentials.password) {
                  credentials = true;
                }
              }
            }
          }
        });
        this.toggleOpenDataLayers({ name: mapItem.layer_name, title: mapItem.title, visibility: true, credentials: credentials });
        this.enableLayers[mapItem.layer_name].getSource().once("change", (evt) => {
          const source = evt.target;
          if (source.getState() === "ready") {
            const feature = this.enableLayers[mapItem.layer_name]
              .getSource()
              .getFeatures()
              .filter((f) => {
                return f.values_[mapItem.id_field] == mapItem.layer_id;
              })[0];
            if (!feature.values_.layer) {
              feature.values_.layer = mapItem.layer_name;
            }
            this.itemsList.openDataClick(feature.values_, false);
            if (document.querySelectorAll("#rightpanel").length == 2) {
              this.rightpanel.element.classList.add("collapsed");
              if (document.querySelectorAll("#rightpanel")[1].classList.contains("collapsed")) {
                document.querySelectorAll("#rightpanel")[1].classList.remove("collapsed");
                document.querySelectorAll("#rightpanel")[1].classList.add("sidebar-right");
                document.querySelectorAll("#items")[1].classList.add("active");
                this.openlayerralationLoader.emit();
                setTimeout(() => {
                  this.showTooltipPublicLayers(mapItem);
                }, 1000);
                setTimeout(() => {
                  this.map.updateSize();
                  const extent = feature.getGeometry().getExtent();
                  const width = extent[2] - extent[0];
                  const height = extent[3] - extent[1];
                  const padding = 0.1;
                  const paddedExtent = [
                    extent[0] - width * padding,
                    extent[1] - height * padding,
                    extent[2] + width * padding,
                    extent[3] + height * padding
                  ];
                  this.map.getView().fit(paddedExtent, { maxZoom: 18, duration: 500 });
                }, 300);
              }
            }
            this.openlayerralationLoader.emit();
            this.showTooltipPublicLayers(mapItem);
            setTimeout(() => {
              this.map.updateSize();
              const extent = feature.getGeometry().getExtent();
              const width = extent[2] - extent[0];
              const height = extent[3] - extent[1];
              const padding = 0.1;
              const paddedExtent = [
                extent[0] - width * padding,
                extent[1] - height * padding,
                extent[2] + width * padding,
                extent[3] + height * padding
              ];
              this.map.getView().fit(paddedExtent, { maxZoom: 18, duration: 500 });
            }, 300);
          }
        });
        if (credentials || mapItem.type === 'geojson') {
          mapItem.id_field = mapItem.type === 'geojson' ? 'layer_id' : mapItem.id_field;
          if (this.enableLayers[mapItem.layer_name].getSource().getState() === "ready") {
            const feature = this.enableLayers[mapItem.layer_name]
              .getSource()
              .getFeatures()
              .filter((f) => {
                return f.values_[mapItem.id_field? mapItem.id_field : 'layer_id'] == mapItem.layer_id;
              })[0];
            if (!feature.values_.layer) {
              feature.values_.layer = mapItem.layer_name;
            }
            this.itemsList.openDataClick(feature.values_, false);
            if (document.querySelectorAll("#rightpanel").length == 2) {
              this.rightpanel.element.classList.add("collapsed");
              if (document.querySelectorAll("#rightpanel")[1].classList.contains("collapsed")) {
                document.querySelectorAll("#rightpanel")[1].classList.remove("collapsed");
                document.querySelectorAll("#rightpanel")[1].classList.add("sidebar-right");
                document.querySelectorAll("#items")[1].classList.add("active");
                this.openlayerralationLoader.emit();
                setTimeout(() => {
                  this.showTooltipPublicLayers(mapItem);
                }, 1000);
                setTimeout(() => {
                  this.map.updateSize();
                  const extent = feature.getGeometry().getExtent();
                  const width = extent[2] - extent[0];
                  const height = extent[3] - extent[1];
                  const padding = 0.1;
                  const paddedExtent = [
                    extent[0] - width * padding,
                    extent[1] - height * padding,
                    extent[2] + width * padding,
                    extent[3] + height * padding
                  ];
                  this.map.getView().fit(paddedExtent, { maxZoom: 18, duration: 500 });
                }, 300);
              }
            }
            this.openlayerralationLoader.emit();
            this.showTooltipPublicLayers(mapItem);
            setTimeout(() => {
              this.map.updateSize();
              const extent = feature.getGeometry().getExtent();
              const width = extent[2] - extent[0];
              const height = extent[3] - extent[1];
              const padding = 0.1;
              const paddedExtent = [
                extent[0] - width * padding,
                extent[1] - height * padding,
                extent[2] + width * padding,
                extent[3] + height * padding
              ];
              this.map.getView().fit(paddedExtent, { maxZoom: 18, duration: 500 });
            }, 300);
          }
        }
      }
    }, 1000);
  }

  openMapItemDetail(mapItem: any) {
    const feature = this.kmls[mapItem.layer_name].features.filter((f) => {
      return f.layer_id == mapItem.layer_id;
    })[0];
    if (!feature.values.layer) {
      feature.values.layer = mapItem.layer_name;
    }
    this.showTooltipOpenlayer(mapItem);
    const featurezoom = this.kmls[mapItem.layer_name]
      .getSource()
      .getFeatures()
      .filter((f) => {
        return f.values_[mapItem.id_field] == mapItem.layer_id;
      })[0];
    this.map
      .getView()
      .fit(featurezoom.getGeometry().getExtent(), { maxZoom: 15 });
    this.itemsList.openDataClick(feature.values, true);
  }

  openMapArcGisItemDetail(mapItem: any) {
    this.layerItemClicked = true;
    let feature: any = {};
    if (this.enableLayers[mapItem.layer_name]?.features) {
      feature = this.enableLayers[mapItem.layer_name].features.filter((f) => {
        return f.layer_id == mapItem.layer_id;
      })[0];
      if (!feature.values.layer) {
        feature.values.layer = mapItem.layer_name;
      }
      this.showTooltipPublicLayers(mapItem);
      const featurezoom = this.enableLayers[mapItem.layer_name].getSource().getFeatures().filter((f) => {
        return f.values_[mapItem.id_field] == mapItem.layer_id;
      })[0];
      if (featurezoom) {
        const geom = featurezoom.getGeometry?.();
        if (geom && typeof geom.getExtent === 'function') {
          this.map.getView().fit(geom.getExtent(), { maxZoom: 15 });
        } else if (this._arcGisLayerExtents[mapItem.layer_name]) {
          this.map.getView().fit(this._arcGisLayerExtents[mapItem.layer_name], { maxZoom: 15 });
        }
      }
    } else if(mapItem.values_) {
      feature['values'] = mapItem.values_;
    }
    this.itemsList.openDataClick(feature.values, true);
  }
  //arcgis layers data mp
  public openDataLayers(type): void {
    switch (type) {
      case 'arcgis':
        if (this.arcGisLayers.length > 0) {
          this.arcGisLayers.forEach((key) => {
            key.name = key.name.replaceAll(' ', '');
            const layername = `${key.name}-${key.layer_name.replace(/\s/g, '')}`;
            if (!this.arcGis_connectedItems.includes(key.layer_name)) {
              this._mapServices.getSymobology(key.url, key.layer_id, this.arcGisToken)
                .pipe(
                  tap((res: any) => {
                    if (this.arcGisToken) {
                      this._mapServices.getSymobologyArcGis(key.layer_id, res.serviceItemId, this.arcGisToken)
                      .pipe(
                        tap((response: any) => {
                          if (arcGisIntegrationSymbology(response)) {
                            if (response.layerDefinition.drawingInfo.renderer.uniqueValueInfos) {
                              response.layerDefinition.drawingInfo.renderer.uniqueValueInfos = arcGisIntegrationSymbologyDefault(response);
                              this.symbolicName.push({ layer_name: layername, symobology: response.layerDefinition.drawingInfo.renderer.uniqueValueInfos });
                              this.symbolicName = collect(this.symbolicName).unique((item => item.layer_name)).all();
                              const extent = this.map.getView().calculateExtent(this.map.getSize());
                              const extent4326 = ol.proj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
                              this.enableLayers[layername] = openLayerMaping(type, this.enableLayers, key, layername, this.arcGisToken, this.geojsonArcGisType, 0, {}, extent4326, response.layerDefinition.drawingInfo.renderer.uniqueValueInfos);
                            } else {
                              this.symbolicName.push({ layer_name: layername, symobology: response.layerDefinition.drawingInfo.renderer });
                              this.symbolicName = collect(this.symbolicName).unique((item => item.layer_name)).all();
                              const extent = this.map.getView().calculateExtent(this.map.getSize());
                              const extent4326 = ol.proj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
                              this.enableLayers[layername] = openLayerMaping(type, this.enableLayers, key, layername, this.arcGisToken, this.geojsonArcGisType, 0, {}, extent4326, response.layerDefinition.drawingInfo.renderer);
                            }
                          } else {
                            if (res) {
                              if (res.drawingInfo) {
                                if (res.drawingInfo?.renderer) {
                                  const renderer = res.drawingInfo.renderer;
                                  const symbology = renderer.uniqueValueInfos? renderer.uniqueValueInfos : renderer;
                                  const extent = this.map.getView().calculateExtent(this.map.getSize());
                                  const extent4326 = ol.proj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
                                  this.enableLayers[layername] = openLayerMaping(type, this.enableLayers, key, layername, this.arcGisToken, this.geojsonArcGisType, 0, {}, extent4326, symbology);
                                } else {
                                  const extent = this.map.getView().calculateExtent(this.map.getSize());
                                  const extent4326 = ol.proj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
                                  this.enableLayers[layername] = openLayerMaping(type, this.enableLayers, key, layername, this.arcGisToken, this.geojsonArcGisType, 0, {}, extent4326);
                                }
                              } else {
                                const extent = this.map.getView().calculateExtent(this.map.getSize());
                                const extent4326 = ol.proj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
                                this.enableLayers[layername] = openLayerMaping(type, this.enableLayers, key, layername, this.arcGisToken, this.geojsonArcGisType, 0, {}, extent4326);
                              }
                            }
                          }
                          this.map.addLayer(this.enableLayers[layername]);
                          this._prefetchLayerExtent(key.url, key.layer_id, layername);
                        }
                        )).subscribe();
                    }
                  }
                  )).subscribe();
            } else {
              this.enableLayers[layername] = openLayerMaping(type, this.enableLayers, key, layername, this.arcGisToken, this.geojsonArcGisType);
              this.map.addLayer(this.enableLayers[layername]);
              this._prefetchLayerExtent(key.url, key.layer_id, layername);
            }
          });
        }
        break;
      case 'subproject':
        // if(this.subProjectQuery.getAll()){
        //   this.subProjectQuery.getAll().forEach(layer => {
        //     this.enableLayers[layer.name]=openLayerMaping(type,this.enableLayers,layer);
        //     this.map.addLayer(this.enableLayers[layer.name]);
        //   });
        // }
        break;
      default:
        break;
    }
  }
  //on reset filter
  public resetFilter(): void {
    this.sidebar.ontoggleChangeAllItem({ checked: false }, 'stakeholder');
    this.sidebar.ontoggleChangeAllItem({ checked: false }, 'issue');
    this.sidebar.ontoggleChangeAllItem({ checked: false }, 'complaints');
    this.sidebar.ontoggleChangeAllItem({ checked: false }, 'requirements');
    this.sidebar.ontoggleChangeAllItem({ checked: false }, 'activity');
    this.owlDateRange = [];
  }
  //right toggle panel
  public toggleRightpanel(data: any) {
    if (
      !collect(this.openDataGetVisible()).contains(true) &&
      !this.kmls["Pontential_Stakeholder"].getVisible() &&
      !this.sidebar.enableItemsLayer['stakeholder'] &&
      !this.sidebar.enableItemsLayer['issue'] &&
      !this.sidebar.enableItemsLayer['complaints'] &&
      !this.sidebar.enableItemsLayer['requirements'] &&
      !this.sidebar.enableItemsLayer['activity'] &&
      !this.sidebar.enableItemsLayer['social'] &&
      !this.sidebar.enableItemsLayer['political'] &&
      !this.sidebar.enableItemsLayer['regulatory'] &&
      !this.sidebar.enableItemsLayer['emotional'] &&
      !this.sidebar.enableItemsLayer['physical'] &&
      !this.sidebar.enableItemsLayer['irrelevant_contexts']
    ) {
      if (!this.rightpanel.element.classList.contains("collapsed")) {
        this.itemsList.onBack();
        this.rightpanel._tabitems[0].querySelector("a").click();
      }
      return;
    }
    if (data.layer && !data.layer.status && data.layer.layer == this.itemsList.itemdetail.current) {
      this.itemsList.onBack();
    } else {
      if (data.layer.status && this.rightpanel.element.classList.contains("collapsed")) {
        this.itemsList.onBack();
        // Hide in mobile Screen
        if (window.innerWidth > 500) {
          this.rightpanel._tabitems[0].querySelector("a").click();
        }

      }
    }
  }
  //update features layers in side panel
  public updateFeatures(obj: any): void {
    this.resetMap(false);
    if (obj.toggle)
      this.toggleRightpanel(obj);
    if (obj.resetFilter && this.dateRange.startDate) {
      this.filterByDate();
    } else {
      if (obj.data) {
        if (obj.layer.layer === 'regulatory' || obj.layer.layer === 'political' || obj.layer.layer === 'social' || obj.layer.layer === 'emotional' || obj.layer.layer === 'physical') {
          this.contextTypeIconsOnBuffer(obj.layer.layer, obj.toggle);
        }
        if (Array.isArray(obj.data) && obj.data.length > 0) {
          this.locationsSbj.next(obj.data);
          this.loadFeatures();
          this.showToggle = true
          // if (obj.layer.layer === 'regulatory' || obj.layer.layer === 'political' || obj.layer.layer === 'social' || obj.layer.layer === 'emotional' || obj.layer.layer === 'physical') {
          //   this.contextTypeIconsOnBuffer(obj.layer.layer, obj.toggle)
          // }
          if (obj.layer.layer!=='irrelevant_contexts'){}
            // this.zoomToAllFeatures();
        }
      }
    }
  }
  //show Tool Tip on Items Features
  public showTooltip(obj: any): void {
    let feature = this.layers[obj.locatable_type]
      .getFeatures()
      .filter((f) => f.get("id") == obj.id);

    if (feature === undefined || feature === null || feature.length == 0) {
      feature = this.layers["lines"]
        .getFeatures()
        .filter((f) => f.get("id") == obj.id);
    }
    const element = document.getElementById(`popup-${this.randomId}`);
    if (feature && feature[0]?.get("name") && feature[0]?.get("link")) {
      if (element && $(element)) {
        let coordinates = feature[0].getGeometry().getCoordinates();
        if (feature[0].get("polygon") && feature[0].get("polygon") == true) {
          coordinates = this.getCenterOfExtent(coordinates);
          this.popupBeingShown = coordinates;
          this.pinTooltipOverlay.setOffset([0, 0]);
          this.pinTooltipOverlay.setPosition(coordinates);
        } else {
          this.popupBeingShown = coordinates;
          this.pinTooltipOverlay.setOffset([0, -45]);
          this.pinTooltipOverlay.setPosition(coordinates);
        }
        $(element).popover({
          placement: "top",
          html: true,
          content: feature[0].get("name"),
        });
        $(element).attr("data-content", feature[0].get("name"));
        $(element).popover("show");
        const popover: any = document.querySelector(".popover");
        const arrow: any = document.querySelector(".popover .arrow");
        popover.style.left = "-100px";
        arrow.style.left = "50%";
        popover.classList.add("hover-tooltip");
      }
    }
  }
  //show Tool Tip on Potential Stakeholder Features
  public showTooltipOpenlayer(obj: any): void {
    const feature = this.kmls[obj.layer_name]
      .getSource()
      .getFeatures()
      .filter((f) => {
        return f.values_[obj.id_field] == obj.layer_id;
      })[0];
    let coordinates;
    const element = document.getElementById(`popup-${this.randomId}`);
    if (feature && feature.values_) {
      if (feature.values_.layer == "Pontential_Stakeholder") {
        coordinates = feature.getGeometry().getCoordinates();
      } else {
        coordinates = feature.getGeometry().getInteriorPoints().getCoordinates();
      }
      if (element && $(element)) {
        this.popupBeingShown = coordinates;
        if (feature.values_.layer == "Pontential_Stakeholder") {
          this.pinTooltipOverlay.setOffset([0, 0]);
          this.pinTooltipOverlay.setPosition(coordinates);
        } else {
          this.pinTooltipOverlay.setOffset([0, 0]);
          this.pinTooltipOverlay.setPosition(coordinates[0]);
        }
        $(element).popover({
          placement: "top",
          html: true,
          content: obj.title,
        });
        $(element).attr("data-content", obj.title);
        $(element).popover("show");
        const popover: any = document.querySelector(".popover");
        const arrow: any = document.querySelector(".popover .arrow");
        popover.style.left = "-100px";
        arrow.style.left = "50%";
      }
    }
  }
  //get center Logic
  getCenterOfExtent(Extent) {
    const X = Extent[0] + (Extent[2] - Extent[0]) / 2;
    const Y = Extent[1] + (Extent[3] - Extent[1]) / 2;
    return [X, Y];
  }
  //show Tool Tip on Open Features
  public showTooltipPublicLayers(obj: any): void {
    const feature = this.enableLayers[obj.layer_name]
      .getSource()
      .getFeatures()
      .filter((f) => {
        return f.values_[obj.id_field] == obj.layer_id;
      })[0];
    let coordinates;
    const element = document.getElementById(`popup-${this.randomId}`);
    if (feature && feature.values_) {
      const geometry = feature.getGeometry();
      if (!geometry || typeof geometry.getExtent !== 'function') {
        return;
      }
      coordinates = this.getCenterOfExtent(geometry.getExtent());
      if (element && $(element)) {
        this.popupBeingShown = coordinates;
        if (coordinates.length > 1) {
          this.pinTooltipOverlay.setOffset([0, 0]);
          this.pinTooltipOverlay.setPosition(coordinates);
        } else {
          this.pinTooltipOverlay.setOffset([0, 0]);
          this.pinTooltipOverlay.setPosition(coordinates[0]);
        }
        $(element).popover({
          placement: "top",
          html: true,
          content: obj.title,
        });
        $(element).attr("data-content", obj.title);
        $(element).popover("show");
        const popover: any = document.querySelector(".popover");
        const arrow: any = document.querySelector(".popover .arrow");
        popover.style.left = "-100px";
        arrow.style.left = "50%";
      }
    }
  }
  //get Zoom Level
  findZoomLevel(zoom, pixel, feature, obj) {
    // let feature = this.layers[obj.locatable_type].getFeatures().filter(f => f.get('id') == obj.id);
    const coordinates = feature[0].getGeometry().getCoordinates();
    pixel = this.map.getPixelFromCoordinate(coordinates);
    const result = this.map.forEachFeatureAtPixel(
      pixel,
      (f) => {
        return f;
      },
      {
        hitTolerance: 1500,
        layerFilter: function (layer) {
          return true;
        },
      }
    );
    if (!result) {
      this.map
        .getView()
        .fit(feature[0].getGeometry().getExtent(), { maxZoom: zoom });
      this.showTooltip(obj);
      this.showAllLayers();
      return;
    }
    const features = result.get("features");
    if ((features && features.length == 1) || zoom > 20) {
      this.map
        .getView()
        .fit(feature[0].getGeometry().getExtent(), { maxZoom: zoom });
      this.showTooltip(obj);
      this.showAllLayers();
    } else {
      zoom = zoom + 2;
      this.map
        .getView()
        .fit(feature[0].getGeometry().getExtent(), { maxZoom: zoom });
      setTimeout(() => {
        this.findZoomLevel(zoom, pixel, feature, obj);
      }, 100);
    }
  }

  showAllLayers() {
    Object.values(this.vectorLayers).forEach((value: any) => {
      value.setVisible(true);
    });
  }

  //TODO: Broken?
  public zoomToPoint(obj: any): void {
    const feature = this.layers[obj.locatable_type]
      .getFeatures()
      .filter((f) => f.get("id") == obj.id);

    if (!feature || feature.length === 0) {
      return;
    }

    const zoom = this.map.getView().getZoom();
    const coordinates = feature[0].getGeometry().getCoordinates();
    const pixel = this.map.getPixelFromCoordinate(coordinates);
    Object.values(this.vectorLayers).forEach((value: any) => {
      if (value.get("name") != feature[0].get("type")) {
        value.setVisible(false);
      }
    });
    setTimeout(() => {
      const result = this.map.forEachFeatureAtPixel(
        pixel,
        (f) => {
          return f;
        },
        {
          hitTolerance: 1500,
          layerFilter: function (layer) {
            return true;
          },
        }
      );
      if (!result) {
        this.map
          .getView()
          .fit(feature[0].getGeometry().getExtent(), { maxZoom: zoom });
        this.showAllLayers();
        return;
      }
      const features = result.get("features");
      if (features && features.length == 1) {
        this.map
          .getView()
          .fit(feature[0].getGeometry().getExtent(), { maxZoom: zoom });
        this.showAllLayers();
      } else {
        this.findZoomLevel(zoom, pixel, feature, obj);
      }

      this.showTooltip(obj);
    }, 50);
  }

  public zoomToAllFeatures(): void {
    const extent = olExtent.createEmpty();
    Object.values(this.layers).forEach((value: any) => {
      olExtent.extend(extent, value.getExtent());
    });
    let padding = [60, 340, 10, 410];
    if (this.rightpanel.element.classList.contains("collapsed")) {
      padding = [60, 10, 10, 410];
    }
    this.map.getView().fit(extent, { padding: padding });
  }

  public resetMap(notify: boolean = true): void {
    this.locationsSbj.next([]);
    this.removeLayers();
    this.showToggle = false;
  }

  public removeLayers(): void {
    Object.values(this.layers).forEach((value: any) => value.clear());
    this.layers["lines"].clear();
  }

  // Show features of active layers
  private loadFeatures(): void {
    const currentLocations = this.locationsSbj.getValue();
    currentLocations.forEach((location: Location) => {
      if (!location.locatable_type) {
        return;
      }
      if (location.points && location.points.coordinates && location.points.coordinates.length > 0) {
        this.loadPoints(location.name, location, location.points.coordinates, location.locatable_type);
      } else if (location.polygons && location.polygons.coordinates && location.polygons.coordinates.length > 0) {
        this.loadPolygons(location, location.polygons.coordinates, location.locatable_type, location.metadata ? location.metadata.color : null);
      } else if (location.lines && location.lines.coordinates && location.lines.coordinates.length > 0) {
        this.loadLines(location.lines.coordinates, location.locatable_type, location.metadata ? location.metadata.color : null);
        location.lines.coordinates.forEach((coordinate: any) => {
          const firstCoordinate = coordinate[0];
          const lastCoordinate = coordinate[coordinate.length - 1];
          this.loadPoints(location.name, location, [firstCoordinate, lastCoordinate], location.locatable_type);
        });
      }
    });
  }
  // Show Tooltip overlay on feature hover
  private applyPinTooltip(): void {
    const selfmap = this;
    let tooltipTimeout: any;
    if (this.pinTooltipOverlay) {
      return;
    }
    const element = document.getElementById(`popup-${this.randomId}`);
    this.pinTooltipOverlay = new Overlay({
      element: element,
      positioning: "top-center",
      stopEvent: true,
      offset: [0, -45],
    });
    this.map.addOverlay(this.pinTooltipOverlay);
    const target = this.map.getTarget();
    // @ts-ignore
    const cursorTarget = typeof target === "string" ? document.querySelector(`#${target}`) : document.querySelector(target);
    this.map.on("pointermove", (evt) => {
      if (evt.dragging) {
        return;
      }
      clearTimeout(tooltipTimeout);
      let feature =  this.map.getFeaturesAtPixel(evt.pixel).filter(f => !f.get('nonInteractive'))[0];
      let featureDetails = feature;
      // We set timeout for showing popover to prevent error on quick switching popover
      // which caused by jquery being late on destroying and showing popover
      if (!this.mapData) {
        clearTimeout(this.popupTimeout);
        if (!feature) {
          const popover: any = document.querySelector(".popover");
          if (popover && this.layerItemClicked) popover.style.display = "block";
          if (popover && !this.layerItemClicked) {
            tooltipTimeout = setTimeout(() => {
              popover.style.display = "none"
              if (popover && popover.classList.contains("hover-tooltip")) popover.classList.remove("hover-tooltip");
              this.popupBeingShown = false;
              // @ts-ignore
              cursorTarget.style.cursor = "pointer";
            }, 1500);
          }
          this.popupBeingShown = false;
          // @ts-ignore
          cursorTarget.style.cursor = "";
          return;
        }

        this.popupTimeout = setTimeout(() => {
          const features = feature.get("features");
          const featureskml = [];
          let parsemap = { title: "" };
          // @ts-ignore
          if (feature.values_.layer) {
            // @ts-ignore
            parsemap = parsemapItem(feature.values_);
            featureskml[0] = feature;
            if (featureskml && featureskml.length == 1)
              feature = featureskml[0];
          } else {
            if (features && features.length == 1) feature = features[0];
          }
          const text =
            feature.get("name") || feature.get("Naam") || parsemap.title;
          if (text) {
            let coordinates;
            // @ts-ignore
            if (feature.values_.layer || feature.get("polygon")) {
              coordinates = feature.getGeometry().getExtent();
              // @ts-ignore
              if (selfmap.enableLayers[feature.values_.layer] || feature.values_.layer == "Pontential_Stakeholder" || feature.get('polygon')) {
                coordinates = this.getCenterOfExtent(coordinates);
              } else {
                // @ts-ignore
                coordinates = feature.getGeometry().getInteriorPoints().getCoordinates();
              }
            } else {
              // @ts-ignore
              coordinates = feature.getGeometry().getCoordinates();
            }
            if (element && $(element) && this.popupBeingShown[0] != coordinates[0]) {
              this.popupBeingShown = coordinates;
              // @ts-ignore
              if (feature.values_.layer || feature.get('polygon')) {
                // @ts-ignore
                if (selfmap.enableLayers[feature.values_.layer] || feature.values_.layer == "Pontential_Stakeholder" || feature.get('polygon')) {
                  this.pinTooltipOverlay.setOffset([0, 0]);
                  this.pinTooltipOverlay.setPosition(coordinates);
                } else {
                  this.pinTooltipOverlay.setOffset([0, 0]);
                  this.pinTooltipOverlay.setPosition(coordinates[0]);
                }
              } else {
                this.pinTooltipOverlay.setOffset([0, -45]);
                this.pinTooltipOverlay.setPosition(coordinates);
              }
              this.layerItemClicked = false;
              $(element).popover({
                placement: "top",
                html: true,
                content: text,
              });
              $(element).attr("data-content", text);
              $(element).popover("show");

              let icon;
              const popover: any = document.querySelector(".popover");
              if (popover && popover.classList.contains("hover-tooltip")) popover.classList.remove("hover-tooltip");
              const popoverContent: any = document.querySelector(".popover-content");
              const tooltipIcon: any = document.querySelector(".tooltip-arrow-icon");
              const arrow: any = document.querySelector(".popover .arrow");
              popover.style.left = "-100px";
              popover.style.top = "-40px";
              arrow.style.left = "50%";
              if (!tooltipIcon) {
                popover.classList.add('project-tooltip-button');
                icon = document.createElement("i");
                icon.className = "uil uil-angle-right-b tooltip-arrow-icon";
                icon.id = `${feature.get('id')}-${feature.get('type')}`
                const wrapper = document.createElement("div");
                wrapper.classList.add("flex", "align-center", "justify-btw");
                while (popoverContent.firstChild) {
                  wrapper.appendChild(popoverContent.firstChild);
                }
                wrapper.appendChild(icon);
                popoverContent.appendChild(wrapper);
              }
              popover._tooltipData = {
                iconId: icon.id,
                features: features,
                featureDetails: featureDetails
              };
              if (popover._handler) {
                popover.removeEventListener("click", popover._handler);
              }
              popover._handler = (event: any) => {
                event.stopPropagation();
                event.preventDefault();
                if (popover._tooltipData.iconId && !popover._tooltipData.iconId.includes("undefined") && popover._tooltipData.iconId.length) {
                  const id = popover._tooltipData.iconId.split('-')[0];
                  const type = popover._tooltipData.iconId.split('-')[1];
                  if (popover._tooltipData.featureDetails && popover._tooltipData.featureDetails.getProperties() && popover._tooltipData.featureDetails.getProperties().features && popover._tooltipData.featureDetails.getProperties().features.length > 0) {
                    if (id && id !== "" && type && popover._tooltipData.features.length == 1) {
                      if (selfmap.rightpanel.element.classList.contains("collapsed"))
                        selfmap.rightpanel._tabitems[0].querySelector("a").click();
                        const item = selfmap.locationsSbj
                          .getValue()
                          .filter((l) => l.id == id && l.locatable_type == type);
                        selfmap.itemsList.onItemClick(item[0], false);
                        selfmap.map.getView().fit(features[0].getGeometry().getExtent(), {
                          maxZoom: selfmap.map.getView().getZoom(),
                        });
                    }
                    //  else if (id && id !== "" && type && (this.contextTypes.includes(type) || type==='irrelevant_contexts') && popover._tooltipData.features.length == 1){
                    //   const item = selfmap.locationsSbj
                    //     .getValue()
                    //     .filter((l) => l.id == id && l.locatable_type == type);
                    //   this.nav(item[0]);
                    // }
                  } else if( popover._tooltipData.featureDetails && popover._tooltipData.featureDetails.getProperties() && (popover._tooltipData.featureDetails.getProperties().type==='allProjects' || popover._tooltipData.featureDetails.getProperties().type==='customerProjects') ) {
                    this.showProjectPolygonPopup(feature);
                    return;
                  } else if ((popover._tooltipData.featureDetails.getProperties().polygon) && type==='irrelevant_contexts') {
                    if (selfmap.rightpanel.element.classList.contains("collapsed")) {
                      selfmap.rightpanel._tabitems[0].querySelector("a").click();
                    }
                    const item = selfmap.locationsSbj
                      .getValue()
                      .filter((l) => l.id == id && l.locatable_type == type);
                    selfmap.itemsList.onItemClick(item[0], false);
                  }
                } else {
                  const feature = popover._tooltipData.featureDetails;
                  if (!feature) return;
                  // const layer = selfmap.select.getLayer(feature);
                  if(feature.getProperties().layer=="Pontential_Stakeholder") {
                    if (selfmap.rightpanel.element.classList.contains("collapsed"))
                      selfmap.rightpanel._tabitems[0].querySelector("a").click();
                    selfmap.itemsList.openDataClick(feature.getProperties(), true);
                    selfmap.select.getFeatures().clear();
                    selfmap.overPassDataZoom(feature);
                    return;
                  }
                  const layer = selfmap.enableLayers[feature.values_.layer];
                  if ((layer as any).values_.layer_type) {
                    if ((layer as any).values_.layer_type == 'subproject') {
                      return
                    }
                  }

                  //Dont show the detail of Pontential_Stakeholder
                  // For context not open the right panel when clicked on the feature
                  if (feature.values_.type !== 'mainPolygon' && feature.values_.type !== '+context' && feature.values_.type !== 'allProjects' && feature.values_.type !== 'customerProjects' && !feature.values_.isBoxOutline && !feature.values_.relevantType) {
                    feature.set("layer", (layer as any).get("name"));
                    if (selfmap.rightpanel.element.classList.contains("collapsed"))
                      selfmap.rightpanel._tabitems[0].querySelector("a").click();
                    if (feature.values_.type !== 'irrelevant_contexts') {
                      selfmap.itemsList.openDataClick(feature.getProperties(), true);
                    }
                    selfmap.select.getFeatures().clear();
                    selfmap.overPassDataZoom(feature);
                  }
                }
              }
              popover.addEventListener("click",popover._handler);
            }
            // @ts-ignore
            cursorTarget.style.cursor = "pointer";
          } else {
            if (this.popupBeingShown) {
              tooltipTimeout = setTimeout(() => {
                $(element).popover("destroy");
                this.popupBeingShown = false;
                // @ts-ignore
                cursorTarget.style.cursor = "pointer";
              }, 1500);
            }
            // @ts-ignore
            cursorTarget.style.cursor = "pointer";
          }
        }, 50);

        const metadata: any = feature.get("metadata");
        if (metadata && metadata.onmouseover) {
          metadata.onmouseover();
        }
      }

      setTimeout(() => {
        if (feature && (feature.get('iconLabel') || feature.get('relevantType'))) {
          // @ts-ignore
          cursorTarget.style.cursor = "pointer";
        } else {
          // @ts-ignore
          cursorTarget.style.cursor = "pointer";
        }
      }, 50)

    });
  }
  //get items icons
  getImageName(feature): string {
    let isStrategicMethod = false;
    if (this.globals.projectConfigs['project.stakeholder_strategy.is_new'])
      isStrategicMethod = true;
    return setItemsIcons(feature, isStrategicMethod);
  }
  // Style for points
  private getIconStyle(iconFileName: string = "issues.png", feature: any, length, anchor: number[] = [0.5, 1]): any {
    let offset_x = 8;
    if (length == 1) {
      // image for single point
      iconFileName = iconFileName.replace("-multiple.png", ".png");
      if (iconFileName !== 'irrelevant_contexts.png' && iconFileName !== "irrelevant_contexts-multiple.png") {
        const name = this.getImageName(feature);
        if (name) iconFileName = iconFileName.replace(".png", name)
      }
    }

    let isContext = false;
    if(iconFileName==='physical.png' || iconFileName==='political.png' || iconFileName==='regulatory.png' || iconFileName==='social.png' || iconFileName==='emotional.png') {
      isContext = true;
      if (feature && feature.values_ && feature.values_.type) {
        const name = `${feature.values_.type}.svg`;
        iconFileName = `marker-relevant-${name}`;
      }
    }

    let isRelevent = true;
    if (iconFileName === "irrelevant_contexts.png" || iconFileName === "irrelevant_contexts-multiple.png") {
      isRelevent = false;
      isContext = true;
      if (feature && feature.values_ && feature.values_.types) {
        const name = `${feature.values_.types.name}.svg`;
        iconFileName = `marker-notrelevant-${name}`;
      }

    }
    if (length.toString().length > 2) offset_x = 8;
    if (length.toString().length == 1) offset_x = 8;
    return new Style({
      image: new Icon({
        anchor: anchor,
        scale:  isContext ? 1.75 : 0.2,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: `/assets/png/${iconFileName}`,
      }),
      text: new Text({
        text: length == 1 ? "" : length.toString(),
        fill: new Fill({
          color: "black",
        }),
        offsetY: -35,
        offsetX: offset_x,
      }),
    });
  }
  // Add points to vector layer
  private loadPoints(name: string, location: Location, coordinates: Coordinate[], type: string): any {
    coordinates.forEach((coordinate) => {
      // @ts-ignore
      const geometry = new Point(coordinate).transform("EPSG:4326", "EPSG:3857").getCoordinates();
      const feature = new Feature({
        geometry: new Point(geometry),
        name: name,
        link: location.link,
        urgency: location.urgency,
        status: location.status,
        id: location.id,
        types: location.types,
        type: type,
        strategy: location.matrices,
        points: location.locatable_type==='irrelevant_contexts' ? location.points: ''
      });

      if (this.layers[type]) this.layers[type].addFeature(feature);
    });
  }

  public loadPolygons(
    location: any,
    coordinates: Coordinate[],
    type: string,
    color?: string
  ): any {
    if (!coordinates) {
      return;
    }
    // @ts-ignore
    const geom = new MultiPolygon(coordinates);
    // @ts-ignore
    const preloadedCoordinates = geom.transform("EPSG:4326", "EPSG:3857").getCoordinates();
    const feature = new Feature({
      geometry: new MultiPolygon(preloadedCoordinates),
      id: location.id,
      name: location.name,
      link: location.link,
      types: location.types,
      type: type,
      polygon: true
    });
    feature.setStyle(this.getStyle(color));
    this.layers["lines"].addFeature(feature);
  }

  public loadLines(
    coordinates: Coordinate[],
    type: string,
    color?: string
  ): any {
    if (!coordinates) {
      return;
    }

    // @ts-ignore
    const geom = new MultiLineString(coordinates);
    // @ts-ignore
    const preloadedCoordinates = geom.transform("EPSG:4326", "EPSG:3857").getCoordinates();
    const feature = new Feature({
      geometry: new MultiLineString(preloadedCoordinates),
    });
    feature.setStyle(this.getStyle(color));
    this.layers["lines"].addFeature(feature);
  }
  // Style for lines
  private getStyle(color?: string): any {
    const rgb = hexToRgb(color || this.basicColor);
    const alphaColor = `rgba(${rgb.r},${rgb.g},${rgb.r},${0.3}`;
    const solidColor = color || this.basicColor;
    return new Style({
      fill: new Fill({
        color: alphaColor,
      }),
      stroke: new Stroke({
        color: solidColor,
        width: 5,
      }),
      image: new CircleStyle({
        radius: 2,
        stroke: new Stroke({
          color: solidColor,
        }),
        fill: new Fill({
          color: alphaColor,
        }),
      }),
    });
  }

  openRangePicker(): void {
    this.pickerDirective.open();
  }

  onChangeGetDate(dateRange: { start: string, end: string }) {
    if (dateRange.start && dateRange.end) {
      this.owlDateRange[0] = dateRange.start
      this.owlDateRange[1] = dateRange.end
      this.filterByDate()
    }
  }

  filterByDate(): void {
    if (this.owlDateRange[0] && this.owlDateRange[1]) {
      this.sidebar.updateDecisionFilter([this.owlDateRange[0],this.owlDateRange[1]]);
      this.sidebar.updateComplaintFilter([this.owlDateRange[0],this.owlDateRange[1]]);
      this.sidebar.updateIssueFilter([this.owlDateRange[0],this.owlDateRange[1]]);
      this.sidebar.updateActivityFilter([this.owlDateRange[0],this.owlDateRange[1]]);
    }
  }
  markDate(e): string {
    const date = e.format().split("T")[0];
    const _class = "";
    const self = this["_ref"]._view.parent.viewContainerParent.component;
    if (self.sidebar) {
      if (self.sidebar.enableItemsLayer['activity']) {
        for (const i in self.sidebar.activities) {
          const a = self.sidebar.activities[i];
          if (a.started_at && a.started_at.split(" ")[0] == date) {
            return "bold";
          }
          if (a.ended_at && a.ended_at.split(" ")[0] == date) {
            return "bold";
          }
        }
      }

      if (self.sidebar.enableItemsLayer['requirements']) {
        for (const i in self.sidebar.requirements) {
          const a = self.sidebar.requirements[i];
          if (a.start_date && a.start_date.split(" ")[0] == date) {
            return "bold";
          }
          if (a.end_date && a.end_date.split(" ")[0] == date) {
            return "bold";
          }
        }
      }

      if (self.sidebar.enableItemsLayer['issue'] && !_class) {
        for (const i in self.sidebar.issues) {
          const a = self.sidebar.issues[i];
          if (a.issues_date && a.issues_date.split(" ")[0] == date) {
            return "bold";
          }
        }
      }
      if (self.sidebar.enableItemsLayer['complaints'] && !_class) {
        for (const i in self.sidebar.complaints) {
          const a = self.sidebar.complaints[i];
          if (a.date && a.date.split(" ")[0] == date) {
            return "bold";
          }
        }
      }
    }
    return _class;
  }

  public ngOnDestroy(): void {
    this.drawing.destroy();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  private drawingSubscription(
    type: string,
    newLocation: Location,
    coordinate: Coordinate,
    eventEmitter: EventEmitter<any>
  ) {
    newLocation = {
      ...newLocation,
      [type]: {
        ...newLocation[type],
        coordinates: [...newLocation[type].coordinates, coordinate],
      },
    };
    eventEmitter.emit();
    let component = null;

    switch (this.locatableType) {
      case "issues":
        component = IssueNewComponent;
        break;
      case "complaints":
        component = ComplaintNewComponent;
        break;
      case "calendars":
        component = ActivityNewComponent;
        break;
      case "stakeholders":
        component = StakeholderNewComponent;
        if (type == "polygons") component = StakeholderNewMapComponent;
        break;
      case "decisions":
      case "requirements":
        component = DecisionNewComponent;
        break;
    }

    let param;
    // eslint-disable-next-line prefer-const
    param = {
      params: {
        locations: newLocation,
        log_timestamp: new Date(),
        stakeholdermap: true,
      },
    };
    if (type == "polygons") {
      const coordinates: any = newLocation.polygons.coordinates[0][0];
      let coordinatesString: string = ' ';
      coordinates.forEach((coord)=> {
        coordinatesString = `${coordinatesString} ${coord[1]} ${coord[0]}`;
      })
      this.overpassAPiCall(coordinatesString);
      this.setDrawingMode(null);
      this.cd.detectChanges();
    } else {
      const dialog = this.dialog.open(component, modalConfig({
        data: param,
        panelClass: 'customized-dialog-container',
      }, ModalEnum.ModalDefault));
      dialog.afterClosed().subscribe((response: any) => {
        this.setOnCreationToggleShow(response, this.locatableType);
      this.setDrawingMode(null);
      this.cd.detectChanges();
      });
    }
    // this.emitValueChange();
  }
  public setDrawingMode(type: any): void {
    if (!type || this.locatableType == type.type || (this.overPassNodes && this.overPassNodes.length)) {
      this.locatableType = "";
      this.sidebar.tool = "";
      this.selectedToolSbj.next(null);
      this.overPassNodes = [];
      this.cd.detectChanges();
      this.toggleOverpassLayer({checked: false})
    } else {
      if (type.type == "calendars_lines") {
        this.purposeToolSbj.next("calendars_lines");
        this.locatableType = "calendars";
        this.selectedToolSbj.next("length");
      } else if (type.type == "stakeholders_polygons") {
        this.purposeToolSbj.next("stakeholders_polygons");
        this.locatableType = "stakeholders";
        this.selectedToolSbj.next("area");
      } else {
        this.purposeToolSbj.next(type.type);
        this.locatableType = type.type;
        this.selectedToolSbj.next("point");
      }
      this.map.updateSize();
    }
  }

  public showOpenDataInSidePanel(layer_name, data) {
    const featureList = [];
    const visibility = this.enableLayers[layer_name].getVisible();
    this.enableLayers[layer_name].getSource().on("change", (evt) => {
      const source = evt.target;
      if (source.getState() === "ready") {
        const feature = this.enableLayers[layer_name].getSource().getFeatures();
        feature.forEach((element, index) => {
          element.values_.layer = layer_name;
          featureList[index] = parsemapItem(element.values_);
          featureList[index].values = element.values_;
        });
        this.enableLayers[layer_name]["features"] = featureList;
      }
      this.activation = true;
      this.itemsList.getOpenDataLayerName(
        layer_name,
        visibility,
        this.enableLayers[layer_name]["features"],
        data
      );
    });
    if (data.credentials) {
      if (this.enableLayers[layer_name].getSource().getState() === "ready") {
        const feature = this.enableLayers[layer_name].getSource().getFeatures();
        feature.forEach((element, index) => {
          element.values_.layer = layer_name;
          featureList[index] = parsemapItem(element.values_);
          featureList[index].values = element.values_;
        });
        this.enableLayers[layer_name]["features"] = featureList;
        this.activation = true;
      }
    }
    if (this.activation)
      this.itemsList.getOpenDataLayerName(layer_name, visibility, this.enableLayers[layer_name]["features"], data);
  }
  public showOpenlayerInSidePanel(layer_name) {
    const featureList = [];
    const visibility = this.kmls[layer_name].getVisible();
    this.kmls[layer_name].getSource().on("change", (evt) => {
      const source = evt.target;
      if (source.getState() === "ready") {
        const feature = this.kmls[layer_name].getSource().getFeatures();
        feature.forEach((element, index) => {
          element.values_.layer = layer_name;
          featureList[index] = parsemapItem(element.values_);
          featureList[index].values = element.values_;
        });
        this.kmls[layer_name]["features"] = featureList;
      }
      this.activation = true;
      this.itemsList.onLayernameGet(
        layer_name,
        visibility,
        this.kmls[layer_name]["features"]
      );
    });
    if (layer_name == "Pontential_Stakeholder") {
      const feature = this.kmls[layer_name].getSource().getFeatures();
      feature.forEach((element, index) => {
        element.values_.layer = layer_name;
        featureList[index] = parsemapItem(element.values_);
        featureList[index].values = element.values_;
      });
      this.kmls[layer_name]["features"] = featureList;
      this.activation = true;
      this.itemsList.onLayernameGet(
        layer_name,
        visibility,
        this.kmls[layer_name]["features"]
      );
    }
    if (this.activation)
      this.itemsList.onLayernameGet(
        layer_name,
        visibility,
        this.kmls[layer_name]["features"]
      );
  }
  public setOnCreationToggleShow(response, type) {
    if (response) {
      response.locatable_type = type;
      if (type == "stakeholders") {
        this.openDataResponse = response;
        this.sidebar.ontoggleChangeAllItem({ checked: true }, 'stakeholder', true);
      } else if (type == "issues") {
        this.openDataResponse = response;
        this.sidebar.ontoggleChangeAllItem({ checked: true }, 'issue', true);
      } else if (type == "complaints") {
        this.openDataResponse = response;
        this.sidebar.ontoggleChangeAllItem({ checked: true }, 'complaints', true);
      } else if (type == "requirements") {
        this.openDataResponse = response;
        this.sidebar.ontoggleChangeAllItem({ checked: true }, 'requirements', true);
      } else if (type == "calendars") {
        response.calendarable_id = response.calendars[0].id;
        this.openDataResponse = response;
        this.sidebar.ontoggleChangeAllItem({ checked: true }, 'activity', true);
      }
      if (this.rightpanel.element.classList.contains("collapsed"))
        this.rightpanel._tabitems[0].querySelector("a").click();
    }
  }
  public perItemGet() {
    let item;
    this.locations$.subscribe(() => {
      if (this.openDataResponse.calendarable_id) {
        item = this.locationsSbj
          .getValue()
          .filter(
            (l) =>
              l.id == this.openDataResponse.calendarable_id &&
              l.locatable_type == this.openDataResponse.locatable_type
          );
      } else {
        item = this.locationsSbj
          .getValue()
          .filter(
            (l) =>
              l.id == this.openDataResponse.id &&
              l.locatable_type == this.openDataResponse.locatable_type
          );
      }
      setTimeout(() => {
        this.itemsList.onItemClick(item[0], true);
      }, 600);
    });
  }
  public onRemoveAllLayersSidePanel() {
    if (
      !collect(this.openDataGetVisible()).contains(true) &&
      !this.kmls["Pontential_Stakeholder"].getVisible() &&
      !this.sidebar.enableItemsLayer['stakeholder'] &&
      !this.sidebar.enableItemsLayer['issue'] &&
      !this.sidebar.enableItemsLayer['complaints'] &&
      !this.sidebar.enableItemsLayer['requirements'] &&
      !this.sidebar.enableItemsLayer['activity']
    ) {
      this.itemsList.onBack();
      this.rightpanel._tabitems[0].querySelector("a").click();
      this.showToggle = false;
    }
  }
  //over pass api work
  public toggleOverpassLayer(event) {
    if (!event.checked) {
      this.toggleOpenData("Pontential_Stakeholder");
      return;
    }
    this.overpassAPI();
  }
  public overpassAPI() {
    this.addPontentialStakeholder(true);
    let subprojectActive;
    this.main_MapCoordinates = '';
    if (this._rout.url.includes('sub')) {
      subprojectActive = this.subProjectQuery.getActive();
      if (subprojectActive.locations.polygons) {
        subprojectActive.locations.polygons.coordinates[0][0].forEach(element => {
          this.main_MapCoordinates = `${this.main_MapCoordinates} ${element[1]} ${element[0]}`;
        });
        this.main_MapCoordinates = this.main_MapCoordinates.replace(/,/g, ' ');
        this.overpassAPiCall(this.main_MapCoordinates);
      } else {
        this.addPontentialStakeholder(true);
      }
    } else {
      if (this.globals.projectConfig.polygons) {
        this.globals.projectConfig.polygons.coordinates[0][0].forEach(element => {
          this.main_MapCoordinates = `${this.main_MapCoordinates} ${element[1]} ${element[0]}`;
        });
        this.main_MapCoordinates = this.main_MapCoordinates.replace(/,/g, ' ');
        this.overpassAPiCall(this.main_MapCoordinates);
      } else {
        this.addPontentialStakeholder(true);
      }
    }
  }
  public addPontentialStakeholder(action = false) {
    const soure = new VectorSource();
    const fill = new Fill({
      color: "#3399CC",
    });
    const styles = [
      new Style({
        image: new CircleStyle({
          fill: fill,
          radius: 5,
        }),
        fill: fill,
      }),
    ];
    this.kmls["Pontential_Stakeholder"] = new VectorLayer({
      // @ts-ignore
      name: "Pontential_Stakeholder",
      source: soure,
      visible: false,
    });
    let feature;
    if (!action) {
      this.overPassNodes.forEach((element: any) => {
        if (element.type == 'node') {
          feature = new Feature({
            // @ts-ignore
            geometry: new Point(new fromLonLat([element.lon, element.lat])),
            naam: (element.tags.name ? element.tags.name : (element.tags.amenity ? element.tags.amenity : (element.tags.shop ? element.tags.shop : element.tags.place))),
            lat: element.lat,
            lon: element.lon,
            id: element.id,
            tag: element.tags,
            relevant: element.tags.name ? true : false,
            phone: element.tags.phone ? element.tags.phone : '',
            email: element.tags.email ? element.tags.email : '',
            layer: 'Pontential_Stakeholder'
          });
          feature.setStyle(styles)
          soure.addFeatures([feature]);
        }
      });
      this.map.addLayer(this.kmls["Pontential_Stakeholder"]);
      this.toggleOpenData("Pontential_Stakeholder");
    }
    this.is_loadOverpassApi = false;
  }
  public overPassDataZoom(feature) {
    this.layerItemClicked = true;
    if (feature.values_.layer == "Pontential_Stakeholder") {
      const featurezoom = this.kmls[feature.values_.layer]
        .getSource()
        .getFeatures()
        .filter((f) => {
          return f.values_['id'] == feature.values_.id;
        })[0];
      this.map
        .getView()
        .fit(featurezoom.getGeometry().getExtent(), { maxZoom: 15 });
    }
  }
  public overpassAPiCall(main_MapCoordinates) {
    let processID;
    this.is_loadOverpassApi = true;
    const overpass_query = overpassApiQuery(main_MapCoordinates);
    this._mapServices.potentialStakeholderBackendAPI(overpass_query)
      .pipe(
        tap((res: any) => {
          processID = res.process_id;
          if (!res.is_process) {
            this.is_loadOverpassApi = false;
            this.overpassApiBackendProcess(res)
          } else {
            if (processID) {
              this.processIDBroadcasting(processID, main_MapCoordinates);
            }
          }
        }),
        catchError(err => {
          this.addPontentialStakeholder(true);
          return throwError(err);
        })
      ).subscribe();
  }
  //broadcasting process api for overpass
  public processIDBroadcasting(processID, main_MapCoordinates): void {
    const interval = setInterval(() => {
      this._projectConfigsService.broadcastingProcess(processID)
        .pipe(
          tap((res: any) => {
            if (!res.ok) {
              clearInterval(interval);
              this.overpassAPiCall(main_MapCoordinates);
            }
          })
        ).subscribe();
    }, 4000);
  }
  //overpass backend process api calling
  public overpassApiBackendProcess(res): void {
    if (res.data) {
      if (res.data.elements.length) {
        this.overPassNodes = res.data.elements;
        this.addPontentialStakeholder();
        this.cd.detectChanges();
      } else {
        this.addPontentialStakeholder(true);
        this.cd.detectChanges();
      }
    }
  }
  //on chnage layer style
  public onChangeLayerStyle(data) {
    this.map.getLayers().forEach(layer => {
      // @ts-ignore
      if (layer.values_.sublayer_name == data.name) {
        setFeatureStyle(data, layer);
      }
    });
  }
  //public layers data load on map
  public loadPublicLayers(data) {
    this.openLayersResp.push(data);
    if (data?.layer?.credentials) {
      if (data.layer.credentials.username && data.layer.credentials.password) {
        this.onLoadPrivateLayers(data);
      }
    } else {
      // For WFS layers, fetch bbox from GetCapabilities
      if (data.type === 'wfs') {
        const url = getRegExpURL(data.layer.url, 'service=wfs');
        const separator = url.includes('?') ? '&' : '?';
        const capabilitiesUrl = `${url}${separator}service=WFS&version=${data.layer.version}&request=GetCapabilities`;
        
        fetch(capabilitiesUrl)
          .then(response => response.text())
          .then(xmlText => {
            const layerBbox = this.extractWfsBbox(xmlText, data.layer_name);
            const bboxToUse = layerBbox && layerBbox.length >= 4 ? layerBbox : this.BBOX;
            this.addWfsLayer(data, bboxToUse);
          })
          .catch(error => {
            console.error('Error loading WFS capabilities:', error);
            this.addWfsLayer(data, this.BBOX);
          });
      } else {
        this.enableLayers[data.layer_name] = openLayerMaping(data.type, this.enableLayers, data.layer, data.layer_name, '', 'pgeojson', data.layer_id, data.metadata, this.BBOX, data.symobology, this);
        this.map.addLayer(this.enableLayers[data.layer_name]);
        if (data.symobology) {
          if (data.symobology.uniqueValueInfos) {
            this.symbolicName.push({ layer_name: data.layer_name, symobology: data.symobology.uniqueValueInfos });
            this.symbolicName = collect(this.symbolicName).unique((item => item.layer_name)).all();
          }
        }
      }
    }

  }

  /**
   * Extract bbox from WFS GetCapabilities XML response
   */
  private extractWfsBbox(xmlText: string, layerName: string): number[] | null {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    
    // Find FeatureType elements (handle both namespaced and non-namespaced)
    const featureTypes = xmlDoc.getElementsByTagName('wfs:FeatureType').length > 0 
      ? xmlDoc.getElementsByTagName('wfs:FeatureType')
      : xmlDoc.getElementsByTagName('FeatureType');
    
    for (let i = 0; i < featureTypes.length; i++) {
      const featureType = featureTypes[i];
      
      // Find layer name
      const nameElement = this.findXmlElement(featureType, ['wfs:Name', 'Name']);
      if (!nameElement) continue;
      
      const foundLayerName = nameElement.textContent.trim();
      if (!this.matchesLayerName(foundLayerName, layerName)) continue;
      
      // Extract bbox coordinates
      const lowerCorner = this.findXmlElement(featureType, ['ows:LowerCorner', 'LowerCorner']);
      const upperCorner = this.findXmlElement(featureType, ['ows:UpperCorner', 'UpperCorner']);
      
      if (!lowerCorner || !upperCorner) continue;
      
      const bbox = this.parseBboxCoordinates(lowerCorner, upperCorner, featureType);
      if (bbox) return bbox;
    }
    
    return null;
  }

  /**
   * Find XML element by trying multiple tag names (namespaced and non-namespaced)
   */
  private findXmlElement(parent: Element, tagNames: string[]): Element | null {
    for (const tagName of tagNames) {
      const element = parent.getElementsByTagName(tagName)[0];
      if (element) return element;
    }
    return null;
  }

  /**
   * Check if found layer name matches the target layer name
   */
  private matchesLayerName(foundName: string, targetName: string): boolean {
    return foundName === targetName || 
           foundName.endsWith(':' + targetName) ||
           foundName === targetName.split(':').pop();
  }

  /**
   * Parse bbox coordinates and convert to EPSG:3857 if needed
   */
  private parseBboxCoordinates(lowerCorner: Element, upperCorner: Element, featureType: Element): number[] | null {
    const lower = lowerCorner.textContent.trim().split(/\s+/).map(Number);
    const upper = upperCorner.textContent.trim().split(/\s+/).map(Number);
    
    if (lower.length < 2 || upper.length < 2) return null;
    
    const [lowerLon, lowerLat] = lower;
    const [upperLon, upperLat] = upper;
    
    // Get CRS information
    const crsAttr = this.getCrsAttribute(featureType);
    
    // Determine if coordinates are already in EPSG:3857
    const is4326 = this.isEpsg4326(lowerLon, lowerLat, upperLon, upperLat);
    const is3857 = crsAttr.includes('3857') && !is4326 && this.isEpsg3857(lowerLon, lowerLat, upperLon, upperLat);
    
    // Calculate min/max coordinates
    const minLon = Math.min(lowerLon, upperLon);
    const minLat = Math.min(lowerLat, upperLat);
    const maxLon = Math.max(lowerLon, upperLon);
    const maxLat = Math.max(lowerLat, upperLat);
    
    if (is3857) {
      // Already in EPSG:3857
      return [minLon, minLat, maxLon, maxLat];
    } else {
      // Convert from EPSG:4326 to EPSG:3857
      const min3857 = fromLonLat([minLon, minLat]);
      const max3857 = fromLonLat([maxLon, maxLat]);
      
      return [
        Math.min(min3857[0], max3857[0]),
        Math.min(min3857[1], max3857[1]),
        Math.max(min3857[0], max3857[0]),
        Math.max(min3857[1], max3857[1])
      ];
    }
  }

  /**
   * Get CRS attribute from FeatureType element
   */
  private getCrsAttribute(featureType: Element): string {
    const crsAttributes = ['crs', 'srsName', 'SRS', 'srs'];
    
    // Check FeatureType attributes
    for (const attr of crsAttributes) {
      const value = featureType.getAttribute(attr);
      if (value) return value;
    }
    
    // Check BoundingBox element if it exists
    const bboxElement = this.findXmlElement(featureType, ['ows:BoundingBox', 'BoundingBox']);
    if (bboxElement) {
      for (const attr of crsAttributes) {
        const value = bboxElement.getAttribute(attr);
        if (value) return value;
      }
    }
    
    // Check CRS child element
    const crsElement = this.findXmlElement(featureType, ['ows:CRS', 'CRS']);
    if (crsElement) {
      return crsElement.textContent || '';
    }
    
    return '';
  }

  /**
   * Check if coordinates look like EPSG:4326
   */
  private isEpsg4326(lowerLon: number, lowerLat: number, upperLon: number, upperLat: number): boolean {
    return Math.abs(lowerLon) <= 180 && Math.abs(lowerLat) <= 90 && 
           Math.abs(upperLon) <= 180 && Math.abs(upperLat) <= 90;
  }

  /**
   * Check if coordinates look like EPSG:3857
   */
  private isEpsg3857(lowerLon: number, lowerLat: number, upperLon: number, upperLat: number): boolean {
    return (Math.abs(lowerLon) > 1000 || Math.abs(lowerLat) > 1000000) && 
           (Math.abs(upperLon) > 1000 || Math.abs(upperLat) > 1000000);
  }

  /**
   * Add WFS layer to map with given bbox
   */
  private addWfsLayer(data: any, bbox: any[]): void {
    this.enableLayers[data.layer_name] = openLayerMaping(
      data.type, 
      this.enableLayers, 
      data.layer, 
      data.layer_name, 
      '', 
      'pgeojson', 
      data.layer_id, 
      data.metadata, 
      bbox, 
      data.symobology, 
      this
    );
    this.map.addLayer(this.enableLayers[data.layer_name]);
    
    if (data.symobology?.uniqueValueInfos) {
      this.symbolicName.push({ 
        layer_name: data.layer_name, 
        symobology: data.symobology.uniqueValueInfos 
      });
      this.symbolicName = collect(this.symbolicName).unique((item => item.layer_name)).all();
    }
  }

  //load public layers
  public onLoadPublicLayers(): void {
    this.publicLayers = new OpenDataLayers(this._mapServices);
  }
  //open data get visibality
  public openDataGetVisible() {
    const openDataVisible = [];
    for (const key in this.enableLayers) {
      openDataVisible.push(this.enableLayers[key].getVisible())
    }
    return openDataVisible;
  }
  // opendata multiple Symobology set
  public openDataMultipleSymobology(layer_name, symobology, type): void {
    if (this.enableLayers[layer_name].getVisible()) {
      this.layerSymbologyInterval.forEach(element => {
        clearInterval(element);
      });
      this.map.getLayers().forEach(layer => {
        // @ts-ignore
        if (layer.values_.sublayer_name == layer_name) {
          // @ts-ignore
          if (layer.features) {
            // @ts-ignore
            layer.getSource().getFeatures().forEach(element => {
              setMultipleSymobologyStyleColor(element, symobology, type)
            });
          }
        }
      });
    }
  }
  //symbology logic added
  public symbologyAdded(layer, type): void {
    if (this.enableLayers[layer].getVisible()) {
      this.symbolicName.forEach((item: any) => {
        if (item.layer_name == layer) {
          this.layerSymbologyInterval.push(setInterval(() => {
            if (this.enableLayers[layer].getSource().getFeatures().length) {
              this.openDataMultipleSymobology(item.layer_name, item.symobology, type)
            }
          }, 1000));
        }
      });
    }
  }
  private _forceSourceLoad(source: any): void {
    if (!source) return;
    const view = this.map.getView();
    const size = this.map.getSize();
    if (!view || !size) return;
    source.refresh();
    source.loadFeatures(view.calculateExtent(size), view.getResolution(), view.getProjection());
  }

  /** Called once at layer-init time while the token is guaranteed fresh. */
  private _prefetchLayerExtent(url: string, layerId: number, layername: string): void {
    this._mapServices.getArcGisLayerExtent(url, layerId, this.arcGisToken)
      .subscribe((res: any) => {
        const ext = res?.extent;
        if (ext && isFinite(ext.xmin)) {
          this._arcGisLayerExtents[layername] = [ext.xmin, ext.ymin, ext.xmax, ext.ymax];
        }
      });
  }

  private _loadWithTargetedExtent(layername: string, data: any): void {
    const source = this.enableLayers[layername]?.getSource();
    // Use the extent cached at init time — avoids any ArcGIS API call here,
    // so an expired token at toggle time (common on PROD) cannot break positioning.
    const extent = this._arcGisLayerExtents[layername];
    if (extent) {
      this.map.getView().fit(extent, { maxZoom: 15 });
    }
    this._forceSourceLoad(source);
    this.showOpenDataInSidePanel(layername, data);
    this.openDataZoomExtentLogic(data);
  }
  //open data extend logics
  public openDataZoomExtentLogic(data): void {
    if (this.enableLayers[data.name].getVisible()) {
      this.layerLoadInterval.push(setInterval(() => {
        if (this.enableLayers[data.name].getSource().getFeatures()) {
          if (this.enableLayers[data.name].getSource().getFeatures().length) {
            this.zoomToOpenDataLayers(data);
          }
        }
      }, 1000));
    }
  }
  //add potential stakeholder in the kml array
  public addPontentialStakeholderToKML() {
    this.kmls["Pontential_Stakeholder"] = new VectorLayer({
      // @ts-ignore
      name: "Pontential_Stakeholder",
      source: new VectorSource(),
      visible: false,
    });
  }
  /*
    On click show relation feature on map
  */
  public showSingleRelationFeature(item: any, show: boolean): void {
    setTimeout(() => {
      if (this.enableLayers[item.layer_name]) {
        if (show) {
          this.enableLayers[item.layer_name].setVisible(true);
          if (this.enableLayers[item.layer_name].getSource().getFeatures().length) {
            this.enableLayers[item.layer_name].getSource().getFeatures().map((feature: any) => {
              if (feature.values_[item.id_field] !== item.layer_id) {
                feature.setStyle(setTransprantFeatures());
              } else {
                feature.setStyle(this.enableLayers[item.layer_name].getStyle());
                this.map.getView().fit(feature.getGeometry().getExtent());
                this.map.getView().setZoom(14);
                this.showTooltipPublicLayers(item);
              }
            });
          }
          else {
            this.showSingleRelationFeature(item, show);
          }
        } else {
          this.enableLayers[item.layer_name].setVisible(false);
        }
      }
    }, 1000);
  }
  /*
    On Load Private Layers On Map
  */
  public onLoadPrivateLayers(data: any): void {
    const url = getRegExpURL(data.layer.url, 'service=wfs');
    const link = `${url}service=WFS&` + `version=${data.layer.version}&request=GetFeature&typename=${data.layer_name}&` + `outputFormat=${encodeURIComponent(resolveWfsOutputFormat(data.layer))}&srsname=EPSG:3857&` + `bbox=${this.BBOX},EPSG:3857`;
    this._mapServices.getPrivateFeatures(data.layer, link)
      .pipe(
        tap(res => {
          this.enableLayers[data.layer_name] = openLayerPrivateMaping(data.type, this.enableLayers, data.layer, data.layer_name, '', 'pgeojson', data.metadata, this.BBOX, res);
          this.map.addLayer(this.enableLayers[data.layer_name]);
        })
      ).subscribe()
  }
  public onShowRelationFeature(layers: any) {
    layers.forEach((layer: any) => {
      this.showSingleRelationFeature(layer.data, layer.show)
    })
  }
  /*
    Sleep function for map loadding
  */
  public sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
  nav(item): void {
    const activeSubProject = this.subProjectQuery.getActive();
    if (activeSubProject) {
      this.location.go(`/${this.globals.project?.code}/sub/${activeSubProject.code}/map/context/${item.id}`);
    } else {
      this.location.go(`/${this.globals.project?.code}/analysis/map/context/${item.id}`);
    }
    const itemToShowTooltip = item;
    const modal = this.dialog.open(ContextDetailComponent, modalConfig({
      data: item,
      panelClass: ['animate__animated', 'animate__slideInRight'],
      disableClose: false,
    }, ModalEnum.SidebarMediumResponsive))
    this.pubsub.updateHistory(modal, ContextDetailComponent, item, item.name, ModalEnum.SidebarMediumResponsive);
      modal?.afterClosed().subscribe(() => {
        this.itemsList.onBack();
        this.select.getFeatures().clear();
        this.sidebar.initSuggestedContextsItems();
        setTimeout(() => {
            this.showTooltipForContextItem(itemToShowTooltip);
        }, 100);
        if (activeSubProject) {
          this.location.go(`/${this.globals.project?.code}/sub/${activeSubProject.code}/analysis`);
        } else {
          this.location.go(`/${this.globals.project?.code}/analysis/map/context`);
        }
      });
  }

  private showTooltipForContextItem(item: any): void {
    let feature = null;
    // Check context layers first
    if (this.contextTypes.includes(item.type) || item.type === 'irrelevant_contexts') {
      feature = this.layers[item.type]?.getFeatures()?.filter((f) => f.get("id") == item.id)[0];
    }
    // If not found in context layers, check other layers
    if (!feature) {
      Object.values(this.layers).forEach((layer: any) => {
          if (!feature) {
              const features = layer.getFeatures()?.filter((f) => f.get("id") == item.id);
              if (features && features.length > 0) {
                  feature = features[0];
              }
          }
      });
    }
    // If feature found, show tooltip
    if (feature) {
      let coordinates;
      if (feature.get("polygon") && feature.get("polygon") == true) {
        coordinates = this.getCenterOfExtent(feature.getGeometry().getExtent());
        this.pinTooltipOverlay.setOffset([0, 0]);
      } else {
        coordinates = feature.getGeometry().getCoordinates();
        this.pinTooltipOverlay.setOffset([0, -45]);
      }

      this.popupBeingShown = coordinates;
      this.pinTooltipOverlay.setPosition(coordinates);
      const element = document.getElementById(`popup-${this.randomId}`);
      if (element && $(element)) {
        const text = feature.get("name") || item.name || '';
        $(element).popover({
            placement: "top",
            html: true,
            content: text,
        });
        $(element).attr("data-content", text);
        $(element).popover("show");

        const popover: any = document.querySelector(".popover");
        const arrow: any = document.querySelector(".popover .arrow");
        if (popover && arrow) {
            popover.style.left = "-100px";
            arrow.style.left = "50%";
        }
      }
    }
  }

  public showProjectPolygonPopup(feature, coordinate?: number[]): void {
    if (this.showProjectPopup) {
      this.closeProjectPopup();
      // return;
    }
    this.lastClickedProjectFeature = feature;
    const featureProps = feature.getProperties();
    const projectName = featureProps.name || 'Unnamed Project';
    const projectType = featureProps.type;
    const project = featureProps.project;
    const element = document.getElementById('project-popup');

    if (element) {
      element.style.display = 'block';
      this.projectPopupData = {
        name: projectName,
        type: projectType,
        project: project
      };
      this.showProjectPopup = true;
      this.cd.detectChanges();

      // Calculate the center of the polygon for popup positioning
      const extent = feature.getGeometry().getExtent();
      const center = this.getCenterOfExtent(extent);

      // Initialize or update project overlay
      if (!this.projectOverlay) {
        this.projectOverlay = new Overlay({
          element: element,
          positioning: 'top-center',
          stopEvent: true,
          offset: [0, -10],
        });
        this.map.addOverlay(this.projectOverlay);
      }
      this.projectOverlay.setPosition(center);
    }
  }

  public closeProjectPopup(): void {
    this.showProjectPopup = false;
    const element = document.getElementById('project-popup');
    if (element) {
      element.style.display = 'none';
    }
    if (this.projectOverlay) {
      this.projectOverlay.setPosition(undefined);
    }
    this.cd.detectChanges();
  }

  public openShareProjectModal(){
    if (this.showProjectPopup) {
      this.closeProjectPopup();
      this.openShareProjectModal();
      return;
    }
    this.dialog.open(
      ProjectShareComponent,
      modalConfig(
        {
          data: this.projectPopupData,
          disableClose: true,
        },
        ModalEnum.ModalMedium
      )
    ).afterClosed().subscribe(() => {
      setTimeout(() => {
        this.showFeatureTooltip(this.lastClickedProjectFeature);
      }, 100);
    });
  }

  private showFeatureTooltip(feature: any): void {
    if (!feature) return;

    const element = document.getElementById(`popup-${this.randomId}`);
    if (!element) return;

    let tooltipTimeout: any;

    // Get feature title (name/Naam/title)
    let parsemap = { title: "" };
    // @ts-ignore
    if (feature.values_?.layer) {
      // @ts-ignore
      parsemap = parsemapItem(feature.values_);
    }
    const text = feature.get("name") || feature.get("Naam") || parsemap.title;
    if (!text) return;

    // Get feature coordinates
    let coordinates: any;
    // @ts-ignore
    if (feature.values_?.layer || feature.get("polygon")) {
      coordinates = feature.getGeometry().getExtent();
      // @ts-ignore
      if (this.enableLayers[feature.values_.layer] || feature.values_.layer === "Pontential_Stakeholder" || feature.get("polygon")) {
        coordinates = this.getCenterOfExtent(coordinates);
      } else {
        // @ts-ignore
        coordinates = feature.getGeometry().getInteriorPoints().getCoordinates();
      }
    } else {
      // @ts-ignore
      coordinates = feature.getGeometry().getCoordinates();
    }

    // Set overlay position
    if (feature.values_?.layer || feature.get("polygon")) {
      this.pinTooltipOverlay.setOffset([0, 0]);
      this.pinTooltipOverlay.setPosition(
        // @ts-ignore
        this.enableLayers[feature.values_.layer] || feature.values_.layer === "Pontential_Stakeholder" || feature.get("polygon")
          ? coordinates
          : coordinates[0]
      );
    } else {
      this.pinTooltipOverlay.setOffset([0, -45]);
      this.pinTooltipOverlay.setPosition(coordinates);
    }

    // Show tooltip
    $(element).popover({
      placement: "top",
      html: true,
      content: text,
    });
    $(element).attr("data-content", text);
    $(element).popover("show");

    // Add arrow icon if not already present
    const popover: any = document.querySelector(".popover");
    const popoverContent: any = document.querySelector(".popover-content");
    const tooltipIcon: any = document.querySelector(".tooltip-arrow-icon");
    const arrow: any = document.querySelector(".popover .arrow");

    if (popover) {
      popover.style.left = "-100px";
      popover.style.top = "-75px";
      if (arrow) arrow.style.left = "50%";

      if (!tooltipIcon) {
        popover.classList.add("project-tooltip-button");
        const icon = document.createElement("i");
        icon.className = "uil uil-angle-right-b tooltip-arrow-icon";
        icon.id = `${feature.get("id")}-${feature.get("type")}`;

        const wrapper = document.createElement("div");
        wrapper.classList.add("flex", "align-center", "justify-btw");
        while (popoverContent.firstChild) {
          wrapper.appendChild(popoverContent.firstChild);
        }
        wrapper.appendChild(icon);
        popoverContent.appendChild(wrapper);
      }
    }

    // Auto-destroy tooltip after 1500ms
    tooltipTimeout = setTimeout(() => {
      $(element).popover("destroy");
    }, 1500);
  }

  getRandomRgba(): [number, number, number, number] {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    const a = 0.6;
    return [r, g, b, a];
  }

  onClickExternalProject(item: any) {
    const layer = this.enableLayers[item.name];
    if (!layer) {
      if (item.type === 'customerProjects' || item.type === 'allProjects') {
        this.showProjectPopupInMapCenter(item);
      }
      return;
    };
    const features = layer.getSource().getFeatures();
    if (!features || features.length === 0) return;
    const feature = features.find(f =>
      f.get('id') === item.id || f.get('name') === item.name
    );
    if (!feature) return;

    this.showProjectPolygonPopup(feature);
    this.fitExtentToFeature(feature);
  }

  fitExtentToFeature(feature: any): void {
    const extent = feature.getGeometry().getExtent();
    this.map.getView().fit(extent, {
      padding: [50, 50, 50, 50],
      maxZoom: 21,
      duration: 1000,
    });
  }

  showProjectPopupInMapCenter(item: any): void {
    const element = document.getElementById('project-popup');
    
    if (element) {
      element.style.display = 'block';
      this.projectPopupData = {
        name: item.name || 'Unnamed Project',
        type: item.type,
        project: item
      };
      this.showProjectPopup = true;
      this.cd.detectChanges();

      // Get the center of the current map view
      const center = this.map.getView().getCenter();

      // Initialize or update project overlay
      if (!this.projectOverlay) {
        this.projectOverlay = new Overlay({
          element: element,
          positioning: 'center-center',
          stopEvent: true,
          offset: [0, 0],
        });
        this.map.addOverlay(this.projectOverlay);
      } else {
        // Update positioning to center-center for this case
        this.projectOverlay.setPositioning('center-center');
        this.projectOverlay.setOffset([0, 0]);
      }
      
      const extent = this.map.getView().calculateExtent(this.map.getSize());
      this.map.getView().fit(extent, {
        padding: [50, 50, 50, 50],
        maxZoom: 10,
        duration: 1000,
      });
      this.projectOverlay.setPosition(center);
    }
  }

  onHoverOrLeaveExternalProjectName(event: any) {
    if (!event || !event.item) return;
    
    const item = event.item;
    const isHover = event.type === 'hover'; // Assuming you pass event type
    const layerName = item.name;
    
    if (!this.enableLayers[layerName]) return;
    
    const layer = this.enableLayers[layerName];
    const features = layer.getSource().getFeatures();
    
    if (!features || features.length === 0) return;
    
    const feature = features.find(f => 
      f.get('id') === item.id || 
      f.get('name') === item.name ||
      f.get('project')?.id === item.id
    );
    
    if (!feature) return;
    
    const element = document.getElementById(`popup-${this.randomId}`);
    if (!element || !$(element)) return;
    
    if (isHover) {
      // Show tooltip on hover
      const extent = feature.getGeometry().getExtent();
      const coordinates = this.getCenterOfExtent(extent);
      
      this.popupBeingShown = true;
      this.pinTooltipOverlay.setOffset([0, 0]);
      this.pinTooltipOverlay.setPosition(coordinates);
      
      const tooltipText = item.name || 'Unnamed Project';
      
      $(element).popover({
        placement: "top",
        html: true,
        content: tooltipText,
      });
      $(element).attr("data-content", tooltipText);
      $(element).popover("show");
      
      const popover: any = document.querySelector(".popover");
      const arrow: any = document.querySelector(".popover .arrow");
      if (popover && arrow) {
        popover.style.left = "-100px";
        arrow.style.left = "50%";
        popover.classList.add("hover-tooltip");
      }
    } else {
      // Hide tooltip on leave
      $(element).popover("hide");
      this.popupBeingShown = false;
    }
  }
}
